import React, { useRef, useState, useEffect, useCallback, useMemo, Fragment as Fragment$1 } from 'react';
import { OpenClickedStatistics, BobjectSelector } from '@bloobirds-it/bobjects';
import { Icon, Tooltip, Text, IconButton, useVisible, Dropdown, CardButton, TimelineItem, Spinner, Timeline, Button, CompoundIcon, Avatar, Label, useToasts, Skeleton } from '@bloobirds-it/flamingo-ui';
import { useBaseSetEmailVariablesValues, useMinimizableModals, useActiveUserId } from '@bloobirds-it/hooks';
import { BobjectTypes, ACTIVITY_FIELDS_LOGIC_ROLE, ACTIVITY_TYPES_VALUES_LOGIC_ROLE, LEAD_FIELDS_LOGIC_ROLE, COMPANY_FIELDS_LOGIC_ROLE, BOUNCED_EMAIL_VALUES_LOGIC_ROLE, CADENCE_TYPES_VALUES_LOGIC_ROLE, OPPORTUNITY_FIELDS_LOGIC_ROLE, ACTIVITY_DIRECTION, MessagesEvents, DATA_SOURCES, REPORTED_VALUES_LOGIC_ROLE, companyUrl, BOBJECT_TYPES, ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE, ACTIVITY_TYPES } from '@bloobirds-it/types';
import { api, toHoursAndMinutes, getTextFromLogicRole, getFieldByLogicRole, getReferencedBobject, getExtensionBobjectByIdFields, formatDateAsText as formatDateAsText$1, isDifferentYearThanCurrent, isToday, getUserTimeZone, getReferencedBobjectFromLogicRole, getValueFromLogicRole, getRelatedBobjectTypeName, removeHtmlTags, convertHtmlToString, injectReferencesSearchProcess, isHtml, parseEmailPixels, EMAIL_MODE, isUrl, formatDate, getFieldById, keepPreviousResponse, getDateTimestampString, generateDatePrefix, linkify, getRelatedBobject, leadUrl } from '@bloobirds-it/utils';
import clsx from 'clsx';
import { useCadences } from '@bloobirds-it/cadence';
import { parseISO, isValid, parse, isSameDay } from 'date-fns';
import format from 'date-fns/format';
import { ContactFlowModal } from '@bloobirds-it/contact-flow';
import { MeetingReportResultModal } from '@bloobirds-it/meeting-report-result';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import useSWR from 'swr';
import WaveSurfer from 'wavesurfer.js';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useRichTextEditorPlugins, deserialize, RichTextEditor, EditorToolbar, EditorToolbarControlsSection, EditorToolbarFontStylesSection, EditorToolbarTextMarksSection, EditorToolbarListsSection, serialize } from '@bloobirds-it/rich-text-editor';
import { useForm, useController } from 'react-hook-form';
import { VirtualInfiniteScroll } from '@bloobirds-it/virtual-infinite-scroll';
import { range } from 'lodash';

var formatDateAsText = function formatDateAsText(text) {
  var patternFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMMM do, yyyy';
  return text ? format(new Date(text), patternFormat) : 'never';
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$g = ".activityTimelineItem-module_activityHeader__JGdnN {\n  display: flex;\n}\n\n.activityTimelineItem-module_activityHeader__JGdnN > div {\n  display: flex;\n  max-width: 100%;\n}\n\n.activityTimelineItem-module_activityHeaderTitle__-Xqpw {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n}\n\n.activityTimelineItem-module_activityHeaderTitleEllipsis__XfMz8 {\n  flex-shrink: 1;\n}\n\n.activityTimelineItem-module_activityHeaderTitleSidePeek__-1CXX {\n  font-size: 14px;\n  padding-bottom: 4px;\n}\n\n.activityTimelineItem-module_activityHeaderSubtitle__GCqka {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 4px;\n  flex-shrink: 1;\n}\n\n.activityTimelineItem-module_timeline_item_wrapper__uj6-F {\n  transition: all 0.5s ease-out;\n}\n\n.activityTimelineItem-module_timeline_item_wrapper__uj6-F > li {\n  padding-left: 14px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.activityTimelineItem-module_timeline_item_wrapper__uj6-F > li > div:first-child > div:nth-child(2) > div {\n  width: 20px;\n  height: 20px;\n}\n\n.activityTimelineItem-module_timeline_item_wrapper_sidePeek__g-9Ad > li {\n  padding: 3px 16px;\n}\n\n.activityTimelineItem-module_timeline_item_wrapper_sidePeek__g-9Ad > li > div:nth-child(2) > div:first-child > div * {\n  font-size: 13px;\n}\n\n.activityTimelineItem-module_timeline_item_wrapper_sidePeek__g-9Ad > li > div:first-child > div:nth-child(2) > div {\n  width: 24px;\n  height: 24px;\n}\n\n.activityTimelineItem-module_timeline_item_wrapper_sidePeek__g-9Ad > li > div:first-child > div:nth-child(2) > div > svg {\n  width: 18px;\n  height: 18px;\n}\n\n.activityTimelineItem-module_attachmentDropdown__lH67r {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  padding: 4px 10px;\n}\n\n.activityTimelineItem-module_attachmentDropdown__lH67r > div {\n  width: 100%;\n}\n\n.activityTimelineItem-module_attachmentClip__kIIem {\n  position: relative;\n  top: -2px;\n}\n\n.activityTimelineItem-module_meetingDurationInfo__OPNXe {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n  margin-left: 4px;\n}\n\n.activityTimelineItem-module_leadName__czXG5 {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n}\n\n.activityTimelineItem-module_leadName__czXG5 > svg {\n  min-width: 12px;\n}\n\n.activityTimelineItem-module_ellipsis__Ae8wN {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.activityTimelineItem-module_rightIconsContainer__JDFE1 {\n  display: flex;\n  gap: 2px;\n}\n\n.activityTimelineItem-module_rightIconsContainer__JDFE1 > div > button {\n  padding: 2px 3px;\n}\n\n.activityTimelineItem-module_descriptionContainer__ozqwf {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n\n.activityTimelineItem-module_descriptionContainer__ozqwf > div:last-child {\n  /* display: flex; */\n  gap: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.activityTimelineItem-module_descriptionContainer__ozqwf > div:last-child > span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  padding-right: 22px;\n  display: contents;\n}\n\n.activityTimelineItem-module_bouncedEmail__xM6nP {\n  margin-right: 4px;\n}\n\n.activityTimelineItem-module_descriptionContainerSidePeek__14R-u {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  padding-right: 22px;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.activityTimelineItem-module_descriptionContainer__ozqwf b {\n  margin-right: 4px;\n}\n\n/* .descriptionContainerSidePeek p,\n.descriptionContainerSidePeek b,\n.descriptionContainerSidePeek div {\n  display: inline-block;\n  margin-right: 5px;\n} */\n\n.activityTimelineItem-module_descriptionContainerSidePeek__14R-u::first-line {\n  padding-bottom: 2px;\n}\n\n.activityTimelineItem-module_descriptionContainerSidePeek__14R-u * {\n  font-size: 13px;\n}\n\n.activityTimelineItem-module_descriptionContainerSidePeek__14R-u > div:first-child {\n  float: left;\n  margin-right: 4px;\n  display: flex;\n}\n\n.activityTimelineItem-module_descriptionContainerSidePeek__14R-u > div:last-child {\n  display: block;\n  overflow: initial;\n}\n\n.activityTimelineItem-module_descriptionContainerSidePeek__14R-u > div:last-child > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  padding-right: 22px;\n  white-space: normal;\n}\n\n.activityTimelineItem-module_descriptionContainer__ozqwf > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.activityTimelineItem-module_callIcon__v4dbl svg {\n  height: 20px !important;\n  width: 20px !important;\n}\n\n.activityTimelineItem-module_emailIcon__jkhvi svg {\n  height: 24px !important;\n  width: 24px !important;\n}\n\n.activityTimelineItem-module_rightIcon__wVTwE svg {\n  height: 16px !important;\n  width: 16px !important;\n}\n";
var styles$g = {"activityHeader":"activityTimelineItem-module_activityHeader__JGdnN","activityHeaderTitle":"activityTimelineItem-module_activityHeaderTitle__-Xqpw","activityHeaderTitleEllipsis":"activityTimelineItem-module_activityHeaderTitleEllipsis__XfMz8","activityHeaderTitleSidePeek":"activityTimelineItem-module_activityHeaderTitleSidePeek__-1CXX","activityHeaderSubtitle":"activityTimelineItem-module_activityHeaderSubtitle__GCqka","timeline_item_wrapper":"activityTimelineItem-module_timeline_item_wrapper__uj6-F","timeline_item_wrapper_sidePeek":"activityTimelineItem-module_timeline_item_wrapper_sidePeek__g-9Ad","attachmentDropdown":"activityTimelineItem-module_attachmentDropdown__lH67r","attachmentClip":"activityTimelineItem-module_attachmentClip__kIIem","meetingDurationInfo":"activityTimelineItem-module_meetingDurationInfo__OPNXe","leadName":"activityTimelineItem-module_leadName__czXG5","ellipsis":"activityTimelineItem-module_ellipsis__Ae8wN","rightIconsContainer":"activityTimelineItem-module_rightIconsContainer__JDFE1","descriptionContainer":"activityTimelineItem-module_descriptionContainer__ozqwf","bouncedEmail":"activityTimelineItem-module_bouncedEmail__xM6nP","descriptionContainerSidePeek":"activityTimelineItem-module_descriptionContainerSidePeek__14R-u","callIcon":"activityTimelineItem-module_callIcon__v4dbl","emailIcon":"activityTimelineItem-module_emailIcon__jkhvi","rightIcon":"activityTimelineItem-module_rightIcon__wVTwE"};
styleInject(css_248z$g);

var css_248z$f = ".lightAttachmentList-module_list__NmBkY {\n  display: flex;\n  padding: 7px 0 7px 0;\n  gap: 12px;\n  border-top: 1px solid var(--lightestBloobirds);\n  border-bottom: 1px solid var(--lightestBloobirds);\n  min-width: 0;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  overflow: auto;\n}\n\n.lightAttachmentList-module_wrappedList__HDldj {\n  flex-wrap: wrap;\n}\n\n.lightAttachmentList-module_item__hnHDw {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--lightestBloobirds);\n  border-radius: 4px;\n  padding: 8px 14px 8px 14px;\n  max-height: 36px;\n  min-width: 90px;\n  max-width: 200px;\n  flex-shrink: 1;\n}\n\n.lightAttachmentList-module_content__Wcru0 {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  white-space: nowrap;\n  min-width: 0;\n  flex-shrink: 1;\n}\n\n.lightAttachmentList-module_content__Wcru0 > *:first-child {\n  flex-shrink: 0;\n}\n\n.lightAttachmentList-module_content__Wcru0 > div {\n  white-space: nowrap;\n  min-width: 0;\n  max-width: 85%;\n  position: relative;\n  flex-shrink: 1;\n}\n\n.lightAttachmentList-module_content__Wcru0 > div > p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.lightAttachmentList-module_content__Wcru0 button {\n  display: none;\n  height: 16px;\n}\n\n.lightAttachmentList-module_item__hnHDw:hover .lightAttachmentList-module_content__Wcru0 button {\n  display: block;\n}\n";
var styles$f = {"list":"lightAttachmentList-module_list__NmBkY","wrappedList":"lightAttachmentList-module_wrappedList__HDldj","item":"lightAttachmentList-module_item__hnHDw","content":"lightAttachmentList-module_content__Wcru0"};
styleInject(css_248z$f);

function LightAttachmentItem(_ref) {
  var name = _ref.name,
    url = _ref.url,
    id = _ref.id;
  return /*#__PURE__*/jsx("div", {
    className: styles$f.item,
    role: "listitem",
    children: /*#__PURE__*/jsxs("div", {
      className: styles$f.content,
      children: [/*#__PURE__*/jsx(Icon, {
        name: "file",
        size: 16,
        color: "softPeanut"
      }), /*#__PURE__*/jsx(Tooltip, {
        title: name,
        position: "top",
        children: /*#__PURE__*/jsx(Text, {
          size: "xs",
          color: "softPeanut",
          children: name
        })
      }), url && /*#__PURE__*/jsx(IconButton, {
        name: "download",
        size: 16,
        color: "bloobirds",
        onClick: function onClick(event) {
          event.stopPropagation();
          api.get('/messaging/mediaFiles/download', {
            params: {
              file_id: id
            },
            responseType: 'blob'
          }).then(function (res) {
            var blobUrl = URL.createObjectURL(res.data);
            var link = document.createElement('a');
            link.download = name;
            link.href = blobUrl;
            link.click();
            link.remove();
          });
        }
      })]
    })
  });
}

function _slicedToArray$7(arr, i) { return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$7(); }
function _nonIterableRest$7() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }
function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$7(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$7(arr) { if (Array.isArray(arr)) return arr; }
var AttachmentsDropdown = /*#__PURE__*/React.forwardRef(function (_ref) {
  var attachedFiles = _ref.attachedFiles,
    betterAttachments = _ref.betterAttachments;
  var anchorRef = useRef();
  var _useVisible = useVisible(false, anchorRef),
    ref = _useVisible.ref,
    visible = _useVisible.visible,
    setVisible = _useVisible.setVisible;
  function toggleVisible(event) {
    event.stopPropagation();
    event.preventDefault();
    setVisible(!visible);
  }
  var hasBetterAttachments = betterAttachments && (betterAttachments === null || betterAttachments === void 0 ? void 0 : betterAttachments.length) > 0;
  return /*#__PURE__*/jsx(Dropdown, {
    ref: ref,
    visible: visible,
    anchor: /*#__PURE__*/jsx(Tooltip, {
      title: "Has attachments",
      position: "top",
      children: /*#__PURE__*/jsx(IconButton, {
        name: "paperclip"
        /*@ts-ignore*/,
        ref: anchorRef,
        size: 12,
        color: "bloobirds",
        onClick: function onClick(event) {
          return toggleVisible(event);
        },
        className: styles$g.attachmentClip
      })
    }),
    width: 214,
    children: /*#__PURE__*/jsx("div", {
      className: styles$g.attachmentDropdown,
      children: hasBetterAttachments ? betterAttachments.map(function (file) {
        return !!file && /*#__PURE__*/jsx(LightAttachmentItem, {
          name: file.name,
          url: file.url,
          id: file.id
        }, file.id);
      }) : attachedFiles.map(function (attachment) {
        return !!attachment && /*#__PURE__*/jsx(LightAttachmentItem, {
          name: attachment
        }, attachment);
      })
    })
  });
});
var MeetingDurationInfo = function MeetingDurationInfo(_ref2) {
  var meetingDuration = _ref2.meetingDuration;
  return /*#__PURE__*/jsxs("div", {
    className: styles$g.meetingDurationInfo,
    children: [/*#__PURE__*/jsx(Icon, {
      name: "clock",
      color: "bloobirds",
      size: 12
    }), /*#__PURE__*/jsx(Text, {
      size: "xs",
      color: "bloobirds",
      children: meetingDuration && toHoursAndMinutes(+meetingDuration)
    })]
  });
};
var BobjectName = function BobjectName(_ref3) {
  var activityBobjectName = _ref3.activityBobjectName,
    _ref3$activityBobject = _ref3.activityBobjectType,
    activityBobjectType = _ref3$activityBobject === void 0 ? BobjectTypes.Lead : _ref3$activityBobject,
    _ref3$ellipsis = _ref3.ellipsis,
    ellipsis = _ref3$ellipsis === void 0 ? undefined : _ref3$ellipsis;
  return activityBobjectName ? /*#__PURE__*/jsxs("div", {
    className: styles$g.leadName,
    style: {
      maxWidth: ellipsis
    },
    children: [/*#__PURE__*/jsx(Icon, {
      name: activityBobjectType === BobjectTypes.Opportunity ? 'fileOpportunity' : activityBobjectType === BobjectTypes.Company ? 'company' : 'person',
      color: "bloobirds",
      size: 12
    }), /*#__PURE__*/jsx(Text, {
      size: "xxs",
      color: "bloobirds",
      className: styles$g.ellipsis,
      children: activityBobjectName
    })]
  }) : /*#__PURE__*/jsx(Fragment, {});
};
var EmailIcons = function EmailIcons(_ref4) {
  var activity = _ref4.activity;
  var openedTimes = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.EMAIL_TIMES_OPENED);
  var clickedTimes = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.EMAIL_TIMES_CLICKED);
  var replyTimes = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.EMAIL_TIMES_REPLIED);
  var hasBeenOpened = +openedTimes > 0;
  var hasBeenClicked = +clickedTimes > 0;
  var hasBeenReplied = +replyTimes > 0;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [hasBeenOpened && /*#__PURE__*/jsx(Tooltip, {
      title: "".concat(openedTimes, " times opened \b ").concat(clickedTimes, " times clicked"),
      position: "top",
      children: /*#__PURE__*/jsx(Icon, {
        name: hasBeenClicked ? 'checkDouble' : 'check',
        color: "bloobirds",
        size: 12
      })
    }), hasBeenReplied && /*#__PURE__*/jsx(Tooltip, {
      title: "Has been replied",
      position: "top",
      children: /*#__PURE__*/jsx(Icon, {
        name: "reply",
        color: "bloobirds",
        size: 12
      })
    })]
  });
};
var ReportedIconButton = function ReportedIconButton(_ref5) {
  var _getFieldByLogicRole;
  var activity = _ref5.activity,
    isReported = _ref5.isReported,
    dataModel = _ref5.dataModel,
    actionsDisabled = _ref5.actionsDisabled;
  var _useState = useState(false),
    _useState2 = _slicedToArray$7(_useState, 2),
    isOpenMeetingReport = _useState2[0],
    setIsOpenMeetingReport = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$7(_useState3, 2),
    isOpenContactFlowModal = _useState4[0],
    setIsOpenContactFlowModal = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray$7(_useState5, 2),
    referenceBobject = _useState6[0],
    setReferenceBobject = _useState6[1];
  var activityType = (_getFieldByLogicRole = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.valueLogicRole;
  function handleOnClick(e) {
    var referencedBobject = getReferencedBobject(activity);
    e.preventDefault();
    e.stopPropagation();
    if (activityType === ACTIVITY_TYPES_VALUES_LOGIC_ROLE.CALL) {
      if (!referenceBobject) getExtensionBobjectByIdFields(referencedBobject.id).then(function (_ref6) {
        var data = _ref6.data;
        return setReferenceBobject(data);
      });
      setIsOpenContactFlowModal(true);
    } else {
      setIsOpenMeetingReport(true);
    }
  }
  function handleClose(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setIsOpenContactFlowModal(false);
    setIsOpenMeetingReport(false);
  }
  return /*#__PURE__*/jsxs("div", {
    className: styles$g.rightIconsContainer,
    onClick: !actionsDisabled && handleOnClick,
    children: [/*#__PURE__*/jsx(Tooltip, {
      title: actionsDisabled ? 'You don’t have permissions required to perform this action' : isReported ? 'Reported' : 'Not reported',
      position: "top",
      children: /*#__PURE__*/jsx(CardButton, {
        size: "small",
        color: isReported ? 'verySoftMelon' : 'transparent',
        variant: isReported ? 'primary' : 'clear',
        children: /*#__PURE__*/jsx(Icon, {
          size: 12,
          color: isReported ? 'extraCall' : 'softPeanut',
          name: "thumbsUp"
        })
      })
    }), isOpenMeetingReport && /*#__PURE__*/jsx(MeetingReportResultModal, {
      handleClose: handleClose,
      activity: activity,
      dataModel: dataModel
    }), isOpenContactFlowModal && referenceBobject && /*#__PURE__*/jsx(ContactFlowModal, {
      onSave: true,
      handleClose: handleClose,
      activity: activity,
      dataModel: dataModel,
      referenceBobject: referenceBobject
    })]
  });
};

var css_248z$e = ".emailDetailsDropdown-module_column__d48kB {\n  width: 400px;\n  padding: 8px 20px 16px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.emailDetailsDropdown-module_row__Hkny9 {\n  display: grid;\n  grid-template-columns: 20% 78%;\n  align-items: start;\n  justify-content: space-between;\n}\n\n.emailDetailsDropdown-module_label__EKQjB {\n  font-family: var(--fontPrimary);\n  margin: 0;\n  grid-auto-flow: column;\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n  grid-column-gap: 4px;\n}\n\n.emailDetailsDropdown-module_value__OILYu {\n  font-family: var(--fontPrimary);\n  margin: 0;\n  grid-auto-flow: column;\n  align-items: center;\n  justify-content: flex-start;\n  grid-column-gap: 4px;\n}\n";
var styles$e = {"column":"emailDetailsDropdown-module_column__d48kB","row":"emailDetailsDropdown-module_row__Hkny9","label":"emailDetailsDropdown-module_label__EKQjB","value":"emailDetailsDropdown-module_value__OILYu"};
styleInject(css_248z$e);

var EmailDetailsDropdown = function EmailDetailsDropdown(props) {
  var metadata = props.metadata,
    date = props.date,
    subject = props.subject;
  var anchorRef = useRef();
  var _useVisible = useVisible(false, anchorRef),
    visible = _useVisible.visible,
    setVisible = _useVisible.setVisible,
    ref = _useVisible.ref;
  var formattedDate = formatDateAsText$1(date, '{date} {month-short} {year}, {time}');
  return /*#__PURE__*/jsx(Dropdown, {
    anchor: /*#__PURE__*/jsx("div", {
      onClick: function onClick(e) {
        setVisible(function (visible) {
          return !visible;
        });
        e.stopPropagation();
      },
      ref: anchorRef,
      children: /*#__PURE__*/jsx(Icon, {
        name: "chevronDown",
        size: 12
      })
    }),
    visible: visible,
    ref: ref,
    arrow: false,
    children: /*#__PURE__*/jsx("div", {
      className: styles$e.column,
      children: metadata && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Row, {
          label: "from:",
          values: metadata.from
        }), /*#__PURE__*/jsx(Row, {
          label: "to:",
          values: metadata.to
        }), metadata.cc && metadata.cc.length > 0 && /*#__PURE__*/jsx(Row, {
          label: "cc:",
          values: metadata.cc
        }), metadata.bcc && metadata.bcc.length > 0 && /*#__PURE__*/jsx(Row, {
          label: "bcc:",
          values: metadata.bcc
        }), /*#__PURE__*/jsx(Row, {
          label: "date:",
          values: formattedDate
        }), /*#__PURE__*/jsx(Row, {
          label: "subject:",
          values: subject
        })]
      })
    })
  });
};
var Row = function Row(props) {
  var label = props.label,
    values = props.values;
  return /*#__PURE__*/jsxs("div", {
    className: styles$e.row,
    children: [/*#__PURE__*/jsx("div", {
      className: styles$e.label,
      children: /*#__PURE__*/jsx(Text, {
        size: "s",
        color: "softPeanut",
        children: label
      })
    }), /*#__PURE__*/jsx("div", {
      className: styles$e.value,
      children: typeof values === 'string' ? /*#__PURE__*/jsx(Text, {
        size: "s",
        color: "peanut",
        children: values || '-'
      }) : values && values.length > 0 ? values.map(function (value) {
        return /*#__PURE__*/jsx(Text, {
          size: "s",
          color: "peanut",
          children: value.name ? "".concat(value.name, " <").concat(value.email, ">") : value.email
        }, "email-info-".concat(label, "-").concat(value));
      }) : /*#__PURE__*/jsx(Text, {
        size: "s",
        color: "peanut",
        children: "-"
      })
    })]
  });
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * This component must be used inside a <Timeline> Parent to be shown properly.
 * On Click has a default action that is meant to be on the main feed to open extended content
 * @param activity
 * @param onClick
 * @param startDisplayDivider
 * @param endDisplayDivider
 * @param activeHover
 * @param extended
 * @param alternativeDescription
 * @param dataModel
 * @param userId
 * @param actionsDisabled
 * @param sidePeekEnabled
 * @constructor
 */
var ActivityTimelineItem = function ActivityTimelineItem(_ref) {
  var _dataModel$findValueB, _dataModel$findValueB2, _parsedAttachedFiles$, _getFieldByLogicRole, _CADENCE_ACTIVITY_TEX, _getFieldByLogicRole2, _activity$id, _cadences$find, _getFieldByLogicRole3, _getFieldByLogicRole4, _getFieldByLogicRole5, _ref$current, _ref$current$firstChi, _ref$current$firstChi2, _ref$current2, _ref$current2$firstCh, _ref$current2$firstCh2, _clsx4;
  var activity = _ref.activity,
    onClick = _ref.onClick,
    startDisplayDivider = _ref.startDisplayDivider,
    endDisplayDivider = _ref.endDisplayDivider,
    _ref$activeHover = _ref.activeHover,
    activeHover = _ref$activeHover === void 0 ? true : _ref$activeHover,
    extended = _ref.extended,
    _ref$alternativeDescr = _ref.alternativeDescription,
    alternativeDescription = _ref$alternativeDescr === void 0 ? false : _ref$alternativeDescr,
    dataModel = _ref.dataModel,
    userId = _ref.userId,
    actionsDisabled = _ref.actionsDisabled,
    sidePeekEnabled = _ref.sidePeekEnabled;
  var activityTypeField = (dataModel === null || dataModel === void 0 ? void 0 : dataModel.findFieldByLogicRole(ACTIVITY_FIELDS_LOGIC_ROLE.TYPE)) || {
    id: ''
  };
  var activitySubjectFields = (dataModel === null || dataModel === void 0 ? void 0 : dataModel.findFieldByLogicRole(ACTIVITY_FIELDS_LOGIC_ROLE.MESSAGE_SUBJECT)) || {
    id: ''
  };
  var activityFromNameFields = (dataModel === null || dataModel === void 0 ? void 0 : dataModel.findFieldByLogicRole(ACTIVITY_FIELDS_LOGIC_ROLE.INBOUND_FORM_NAME)) || {
    id: ''
  };
  var activityBodyFields = (dataModel === null || dataModel === void 0 ? void 0 : dataModel.findFieldByLogicRole(ACTIVITY_FIELDS_LOGIC_ROLE.MESSAGE_BODY)) || {
    id: ''
  };
  var activityDirectionFields = (dataModel === null || dataModel === void 0 ? void 0 : dataModel.findFieldByLogicRole(ACTIVITY_FIELDS_LOGIC_ROLE.DIRECTION)) || {
    id: ''
  };
  var activityNoteField = (dataModel === null || dataModel === void 0 ? void 0 : dataModel.findFieldByLogicRole(ACTIVITY_FIELDS_LOGIC_ROLE.NOTE)) || {
    id: ''
  };
  var activityTimeField = (dataModel === null || dataModel === void 0 ? void 0 : dataModel.findFieldByLogicRole(ACTIVITY_FIELDS_LOGIC_ROLE.TIME)) || {
    id: ''
  };
  if (!(activity !== null && activity !== void 0 && activity.raw)) {
    return null;
  }
  var activityType = activity.raw.contents[activityTypeField === null || activityTypeField === void 0 ? void 0 : activityTypeField.id];
  var activitySubject = activity.raw.contents[activitySubjectFields === null || activitySubjectFields === void 0 ? void 0 : activitySubjectFields.id];
  var activityDirection = activity.raw.contents[activityDirectionFields === null || activityDirectionFields === void 0 ? void 0 : activityDirectionFields.id];
  var activityBody = activity.raw.contents[activityBodyFields === null || activityBodyFields === void 0 ? void 0 : activityBodyFields.id];
  var activityNote = activity.raw.contents[activityNoteField === null || activityNoteField === void 0 ? void 0 : activityNoteField.id];
  var activityFormName = activity.raw.contents[activityFromNameFields === null || activityFromNameFields === void 0 ? void 0 : activityFromNameFields.id];
  var activityTime = activity.raw.contents[activityTimeField === null || activityTimeField === void 0 ? void 0 : activityTimeField.id];
  var isDifferentYear = isDifferentYearThanCurrent(activityTime);
  var isThisDay = isToday(activityTime, getUserTimeZone());
  var timeToShow = formatDateAsText(parseISO(activityTime), isDifferentYear ? 'dd MMM, yyyy' : isThisDay ? 'HH:mm' : 'dd MMM');
  if (!activityType) {
    return null;
  }
  var activityTypeLogicRole = dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$findValueB = dataModel.findValueById(activityType)) === null || _dataModel$findValueB === void 0 ? void 0 : _dataModel$findValueB.logicRole;
  var activityDirectionValue = dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$findValueB2 = dataModel.findValueById(activityDirection)) === null || _dataModel$findValueB2 === void 0 ? void 0 : _dataModel$findValueB2.name;
  var activityLead = getReferencedBobjectFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.LEAD);
  var activityLeadName = getTextFromLogicRole(activityLead, LEAD_FIELDS_LOGIC_ROLE.FULL_NAME);
  var activityCompany = getReferencedBobjectFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.COMPANY);
  var activityCompanyName = getTextFromLogicRole(activityCompany, COMPANY_FIELDS_LOGIC_ROLE.NAME);
  var activityIsReported = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.REPORTED) === 'Yes';

  // Email
  var activityAttachedFiles = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.ATTACHED_FILES);
  var parsedAttachedFiles = activityAttachedFiles && JSON.parse(activityAttachedFiles);
  var activityLeadEmail = getTextFromLogicRole(activityLead, LEAD_FIELDS_LOGIC_ROLE.EMAIL);
  var activityAttachments = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.ATTACHMENTS);
  var parsedAttachments = activityAttachments && JSON.parse(activityAttachments);
  var hasAttachedFiles = activityAttachedFiles && (parsedAttachedFiles === null || parsedAttachedFiles === void 0 ? void 0 : (_parsedAttachedFiles$ = parsedAttachedFiles.filter(function (att) {
    return !!att;
  })) === null || _parsedAttachedFiles$ === void 0 ? void 0 : _parsedAttachedFiles$.length) !== 0;
  var isBouncedEmail = ((_getFieldByLogicRole = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.IS_BOUNCED_EMAIL)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.valueLogicRole) === BOUNCED_EMAIL_VALUES_LOGIC_ROLE.YES;
  var activityEmailMetadata = getValueFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.EMAIL_METADATA);
  var activityEmailInfo = activityEmailMetadata ? JSON.parse(activityEmailMetadata) : {};
  var activityEmailLeads = [];
  if (activityEmailMetadata) {
    var _activityEmailInfo$to, _activityEmailInfo$cc;
    if ((activityEmailInfo === null || activityEmailInfo === void 0 ? void 0 : (_activityEmailInfo$to = activityEmailInfo.to) === null || _activityEmailInfo$to === void 0 ? void 0 : _activityEmailInfo$to.length) > 0) {
      activityEmailInfo.to.map(function (to) {
        if (to.name && to.name !== activityLeadName) activityEmailLeads.push(to.name);else if (to.email && to.email !== activityLeadEmail) activityEmailLeads.push(to.email.split('@')[0]);
      });
    }
    if ((activityEmailInfo === null || activityEmailInfo === void 0 ? void 0 : (_activityEmailInfo$cc = activityEmailInfo.cc) === null || _activityEmailInfo$cc === void 0 ? void 0 : _activityEmailInfo$cc.length) > 0) {
      activityEmailInfo.cc.map(function (cc) {
        if (cc.name && cc.name !== activityLeadName) activityEmailLeads.push(cc.name);else if (cc.email && cc.email !== activityLeadEmail) activityEmailLeads.push(cc.email.split('@')[0]);
      });
    }
  }

  // Meeting
  var meetingDuration = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_DURATION);
  var meetingTitle = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.TITLE);
  var meetingResult = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_RESULT);

  // Call
  var callDuration = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_DURATION);
  var hasAudioRecording = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_RECORD_URL);
  var callResult = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_RESULT);

  // Cadence
  var CADENCE_ACTIVITY_TEXT = (_CADENCE_ACTIVITY_TEX = {}, _defineProperty$d(_CADENCE_ACTIVITY_TEX, CADENCE_TYPES_VALUES_LOGIC_ROLE.RESCHEDULE, 'rescheduled'), _defineProperty$d(_CADENCE_ACTIVITY_TEX, CADENCE_TYPES_VALUES_LOGIC_ROLE.STARTED, 'started'), _defineProperty$d(_CADENCE_ACTIVITY_TEX, CADENCE_TYPES_VALUES_LOGIC_ROLE.CONFIGURE, 'started'), _defineProperty$d(_CADENCE_ACTIVITY_TEX, CADENCE_TYPES_VALUES_LOGIC_ROLE.STOPPED, 'stopped'), _defineProperty$d(_CADENCE_ACTIVITY_TEX, CADENCE_TYPES_VALUES_LOGIC_ROLE.ENDED, 'ended'), _CADENCE_ACTIVITY_TEX);
  var referenceBobjectType = getRelatedBobjectTypeName(activity);
  var cadenceId = (_getFieldByLogicRole2 = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CADENCE)) === null || _getFieldByLogicRole2 === void 0 ? void 0 : _getFieldByLogicRole2.value;
  var _useCadences = useCadences(referenceBobjectType, activity === null || activity === void 0 ? void 0 : (_activity$id = activity.id) === null || _activity$id === void 0 ? void 0 : _activity$id.accountId, undefined, undefined, undefined, true),
    cadences = _useCadences.cadences;
  var activityCadence = cadences === null || cadences === void 0 ? void 0 : (_cadences$find = cadences.find(function (cadence) {
    return (cadence === null || cadence === void 0 ? void 0 : cadence.id) === cadenceId;
  })) === null || _cadences$find === void 0 ? void 0 : _cadences$find.name;
  var activityCadenceStatusLR = (_getFieldByLogicRole3 = getFieldByLogicRole(activity, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.CADENCE)) === null || _getFieldByLogicRole3 === void 0 ? void 0 : _getFieldByLogicRole3.valueLogicRole;
  var activityCadenceStatus = CADENCE_ACTIVITY_TEXT[activityCadenceStatusLR];

  // Status
  var activityStatusUpdate = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.STATUS_TITLE);
  var activityStatus = getTextFromLogicRole(activity, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.STATUS);
  var isLeadStatusUpdate = (activityStatus === null || activityStatus === void 0 ? void 0 : activityStatus.includes('lead')) || (activityStatus === null || activityStatus === void 0 ? void 0 : activityStatus.includes('Lead'));
  var isOpportunityStatusUpdate = (activityStatus === null || activityStatus === void 0 ? void 0 : activityStatus.includes('opportunity')) || (activityStatus === null || activityStatus === void 0 ? void 0 : activityStatus.includes('Opportunity'));
  var opportunityField = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.OPPORTUNITY);
  var opportunity = opportunityField === null || opportunityField === void 0 ? void 0 : opportunityField.referencedBobject;
  var opportunityName = getTextFromLogicRole(opportunity, OPPORTUNITY_FIELDS_LOGIC_ROLE.NAME);
  var opportunityStage = getTextFromLogicRole(opportunity, OPPORTUNITY_FIELDS_LOGIC_ROLE.STATUS);
  var leadAssignee = ((_getFieldByLogicRole4 = getFieldByLogicRole(activityLead, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO)) === null || _getFieldByLogicRole4 === void 0 ? void 0 : _getFieldByLogicRole4.value) || ( // @ts-ignore
  activityLead === null || activityLead === void 0 ? void 0 : activityLead.assignedTo);
  var oppAssignee = ((_getFieldByLogicRole5 = getFieldByLogicRole(opportunity, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO)) === null || _getFieldByLogicRole5 === void 0 ? void 0 : _getFieldByLogicRole5.value) || ( // @ts-ignore
  opportunity === null || opportunity === void 0 ? void 0 : opportunity.assignedTo);
  var assignedToActiveUser = leadAssignee === userId || oppAssignee === userId;
  var descriptionClass = clsx(styles$g.descriptionContainer, _defineProperty$d({}, styles$g.descriptionContainerSidePeek, sidePeekEnabled));
  var getBobjectNameProps = function getBobjectNameProps() {
    var activityBobjectName = '';
    var activityBobjectType = BobjectTypes.Lead;
    if (activityLeadName) {
      activityBobjectName = activityLeadName;
      if ((activityEmailLeads === null || activityEmailLeads === void 0 ? void 0 : activityEmailLeads.length) > 0) {
        activityBobjectName += ', ' + activityEmailLeads.join(', ');
      }
    } else if ((activityEmailLeads === null || activityEmailLeads === void 0 ? void 0 : activityEmailLeads.length) > 0) {
      activityBobjectName += activityEmailLeads.join(', ');
    } else if (opportunityName) {
      activityBobjectName = opportunityName;
      activityBobjectType = BobjectTypes.Opportunity;
    } else if (activityCompanyName) {
      activityBobjectName = activityCompanyName;
      activityBobjectType = BobjectTypes.Company;
    }
    return {
      activityBobjectName: activityBobjectName,
      activityBobjectType: activityBobjectType
    };
  };
  var activityFields = function activityFields(activityTypeLogicRole) {
    switch (activityTypeLogicRole) {
      case ACTIVITY_TYPES_VALUES_LOGIC_ROLE.EMAIL:
        return {
          icon: /*#__PURE__*/jsx("div", {
            className: sidePeekEnabled && styles$g.emailIcon,
            children: /*#__PURE__*/jsx(Icon, {
              name: activityDirectionValue === ACTIVITY_DIRECTION.OUTGOING ? 'emailOutgoingAlter' : 'emailIncomingAlter',
              color: activityDirectionValue === ACTIVITY_DIRECTION.OUTGOING ? 'tangerine' : 'lightestTangerine',
              size: 20
            })
          }),
          color: activityDirectionValue === ACTIVITY_DIRECTION.OUTGOING ? 'lightestTangerine' : 'tangerine',
          subject: activitySubject || 'No subject',
          description: /*#__PURE__*/jsxs("div", {
            className: descriptionClass,
            children: [/*#__PURE__*/jsx(BobjectName, _objectSpread$7(_objectSpread$7({}, getBobjectNameProps()), {}, {
              ellipsis: "80%"
            })), /*#__PURE__*/jsx(EmailDetailsDropdown, {
              metadata: activityEmailInfo,
              date: activityTime,
              subject: activitySubject
            }), activityBody && (activityEmailLeads.length === 0 || sidePeekEnabled) && /*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx("span", {
                children: activityBody ? removeHtmlTags(activityBody) : null
              })
            })]
          }),
          date: timeToShow,
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds',
          rightIcon: /*#__PURE__*/jsxs("div", {
            className: sidePeekEnabled && styles$g.rightIcon,
            children: [isBouncedEmail && /*#__PURE__*/jsx(Icon, {
              className: styles$g.bouncedEmail,
              name: "statusCircle",
              size: 6,
              color: "extraMeeting"
            }), hasAttachedFiles && /*#__PURE__*/jsx(AttachmentsDropdown, {
              attachedFiles: parsedAttachedFiles,
              betterAttachments: parsedAttachments
            }), /*#__PURE__*/jsx(EmailIcons, {
              activity: activity
            })]
          })
        };
      case ACTIVITY_TYPES_VALUES_LOGIC_ROLE.MEETING:
        return {
          icon: 'calendar',
          color: 'lightestMeeting',
          iconColor: 'extraMeeting',
          subject: meetingTitle ? meetingTitle : 'Meeting arranged',
          extraSubtitle: meetingDuration && !alternativeDescription && /*#__PURE__*/jsx(MeetingDurationInfo, {
            meetingDuration: meetingDuration
          }),
          description: /*#__PURE__*/jsxs("div", {
            className: descriptionClass,
            children: [activityLead && /*#__PURE__*/jsx(BobjectName, {
              activityBobjectName: activityLeadName
            }), /*#__PURE__*/jsxs("div", {
              children: [meetingResult && /*#__PURE__*/jsx("b", {
                children: meetingResult
              }), activityNote && /*#__PURE__*/jsxs("span", {
                children: [/*#__PURE__*/jsx("b", {
                  children: "Note: "
                }), " ", activityNote]
              })]
            })]
          }),
          date: timeToShow,
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds',
          rightIcon: /*#__PURE__*/jsx("div", {
            className: sidePeekEnabled && styles$g.rightIcon,
            children: /*#__PURE__*/jsx(ReportedIconButton, {
              activity: activity,
              isReported: activityIsReported,
              dataModel: dataModel,
              actionsDisabled: actionsDisabled && !assignedToActiveUser
            })
          })
        };
      case ACTIVITY_TYPES_VALUES_LOGIC_ROLE.CALL:
        return {
          icon: /*#__PURE__*/jsx("div", {
            className: sidePeekEnabled && styles$g.callIcon,
            children: /*#__PURE__*/jsx(Icon, {
              name: activityDirectionValue === ACTIVITY_DIRECTION.OUTGOING ? 'callOutgoing' : 'callIncoming',
              color: activityDirectionValue === ACTIVITY_DIRECTION.MISSED ? 'extraMeeting' : 'extraCall',
              size: 16
            })
          }),
          color: activityDirectionValue === ACTIVITY_DIRECTION.MISSED ? 'lightestMeeting' : 'lightestCall',
          iconColor: 'extraCall',
          subject: activityDirectionValue + ' call ',
          date: timeToShow,
          description: alternativeDescription ? /*#__PURE__*/jsxs(Text, {
            size: "xxs",
            color: "softPeanut",
            children: ["Call with ", activityLeadName, " from ", activityCompanyName]
          }) : /*#__PURE__*/jsxs("div", {
            className: descriptionClass,
            children: [activityLead && /*#__PURE__*/jsx(BobjectName, {
              activityBobjectName: activityLeadName
            }), callResult && /*#__PURE__*/jsx("b", {
              children: callResult
            }), activityNote && /*#__PURE__*/jsxs("span", {
              children: [/*#__PURE__*/jsx("b", {
                children: "Note:"
              }), convertHtmlToString(activityNote)]
            }), !callResult && !activityNote && /*#__PURE__*/jsx("span", {})]
          }),
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds',
          rightIcon: /*#__PURE__*/jsxs("div", {
            className: clsx(styles$g.descriptionContainer, _defineProperty$d({}, styles$g.rightIcon, sidePeekEnabled)),
            children: [/*#__PURE__*/jsx(ReportedIconButton, {
              activity: activity,
              isReported: Boolean(callResult),
              dataModel: dataModel,
              actionsDisabled: actionsDisabled && !assignedToActiveUser
            }), hasAudioRecording && /*#__PURE__*/jsx(Tooltip, {
              title: "Recording",
              position: "top",
              children: /*#__PURE__*/jsx(Icon, {
                name: "voicemail",
                color: "bloobirds",
                size: 12
              })
            }), callDuration && /*#__PURE__*/jsx(Text, {
              size: "xxs",
              color: "softPeanut",
              children: new Date(callDuration * 1000).toISOString().substring(14, 19)
            })]
          })
        };
      case ACTIVITY_TYPES_VALUES_LOGIC_ROLE.LINKEDIN:
        return {
          icon: 'linkedin',
          color: 'verySoftBloobirds',
          iconColor: 'darkBloobirds',
          subject: activityBody ? 'Linkedin conversation' : 'Manually logged activity',
          description: /*#__PURE__*/jsxs("div", {
            className: descriptionClass,
            children: [activityLead && /*#__PURE__*/jsx(BobjectName, {
              activityBobjectName: activityLeadName
            }), /*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx("span", {
                children: alternativeDescription ? '' : activityBody ? activityBody : activityNote ? activityNote : null
              })
            })]
          }),
          date: timeToShow,
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds'
        };
      case ACTIVITY_TYPES_VALUES_LOGIC_ROLE.NOTE:
        return {
          icon: 'noteAction',
          color: 'banana',
          iconColor: 'peanut',
          subject: activityLeadName ? activityLeadName + ' note' : 'Note',
          subtitle: activityNote && !sidePeekEnabled ? removeHtmlTags(activityNote) : null,
          description: /*#__PURE__*/jsxs("div", {
            className: descriptionClass,
            children: [activityLead && /*#__PURE__*/jsx(BobjectName, {
              activityBobjectName: activityLeadName
            }), sidePeekEnabled && activityNote && /*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx("span", {
                children: removeHtmlTags(activityNote)
              })
            })]
          }),
          date: timeToShow,
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds'
        };
      case ACTIVITY_TYPES_VALUES_LOGIC_ROLE.INBOUND:
        return {
          icon: 'download',
          color: 'lightestBanana',
          iconColor: 'banana',
          subject: 'Inbound activity',
          subtitle: activityFormName ? "\"".concat(activityFormName, "\"") : '',
          description: activityLead && /*#__PURE__*/jsx(BobjectName, {
            activityBobjectName: activityLeadName
          }),
          date: formatDateAsText(parseISO(activityTime), 'dd MMM'),
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds'
        };
      case 'ACTIVITY__TYPE__CADENCE':
        return {
          icon: 'cadence',
          color: 'verySoftPurple',
          iconColor: 'lightPurple',
          subject: activityCadenceStatusLR ? "Cadence ".concat(activityCadenceStatus) : '',
          description: /*#__PURE__*/jsxs("div", {
            className: descriptionClass,
            children: [activityLead && /*#__PURE__*/jsx(BobjectName, {
              activityBobjectName: activityLeadName
            }), /*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx("span", {
                children: activityCadence ? "\"".concat(activityCadence, "\"") : ''
              })
            })]
          }),
          date: timeToShow,
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds'
        };
      case 'ACTIVITY__TYPE__STATUS':
        return {
          icon: isLeadStatusUpdate ? 'person' : isOpportunityStatusUpdate ? 'fileOpportunity' : 'company',
          color: 'lightPeanut',
          iconColor: 'softPeanut',
          subject: activityStatusUpdate ? activityStatusUpdate : 'Status update',
          description: /*#__PURE__*/jsxs("div", {
            className: descriptionClass,
            children: [(activityLead || opportunity) && /*#__PURE__*/jsx(BobjectName, {
              activityBobjectName: opportunity ? opportunityName : activityLeadName,
              activityBobjectType: opportunity ? BobjectTypes.Opportunity : BobjectTypes.Lead
            }), /*#__PURE__*/jsx("div", {
              children: opportunityStage && /*#__PURE__*/jsx("b", {
                children: opportunityStage
              })
            })]
          }),
          date: timeToShow,
          backgroundColor: extended ? 'lightestBloobirds' : 'lightestBloobirds'
        };
    }
  };

  // @ts-ignore
  var activityData = activityTypeLogicRole ? activityFields(activityTypeLogicRole) : undefined;
  var ref = useRef();
  var showTooltip =
  // @ts-ignore
  (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$firstChi = _ref$current.firstChild) === null || _ref$current$firstChi === void 0 ? void 0 : (_ref$current$firstChi2 = _ref$current$firstChi.firstChild) === null || _ref$current$firstChi2 === void 0 ? void 0 : _ref$current$firstChi2.offsetWidth) < ( // @ts-ignore
  ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$firstCh = _ref$current2.firstChild) === null || _ref$current2$firstCh === void 0 ? void 0 : (_ref$current2$firstCh2 = _ref$current2$firstCh.firstChild) === null || _ref$current2$firstCh2 === void 0 ? void 0 : _ref$current2$firstCh2.scrollWidth);
  var timelineItemWrapperClasses = clsx(styles$g.timeline_item_wrapper, _defineProperty$d({}, styles$g.timeline_item_wrapper_sidePeek, sidePeekEnabled));
  return /*#__PURE__*/jsx("div", {
    className: timelineItemWrapperClasses,
    children: /*#__PURE__*/jsx(TimelineItem, {
      size: 'small'
      // @ts-ignore
      ,
      data: activityData,
      startDisplayDivider: startDisplayDivider,
      endDisplayDivider: endDisplayDivider,
      onClick: onClick ? function () {
        return onClick(activity);
      } : undefined,
      backgroundColor: activityData === null || activityData === void 0 ? void 0 : activityData.backgroundColor,
      activeHover: activeHover,
      children: /*#__PURE__*/jsxs("div", {
        className: styles$g.activityHeader,
        ref: ref,
        children: [/*#__PURE__*/jsx(Tooltip, {
          title: showTooltip && (activityData === null || activityData === void 0 ? void 0 : activityData.subject),
          position: "top",
          delay: 200,
          children: /*#__PURE__*/jsx(Text, {
            size: "xs",
            weight: "bold",
            className: clsx(styles$g.activityHeaderTitle, (_clsx4 = {}, _defineProperty$d(_clsx4, styles$g.activityHeaderTitleEllipsis, !(activityData !== null && activityData !== void 0 && activityData.subtitle)), _defineProperty$d(_clsx4, styles$g.activityHeaderTitleSidePeek, sidePeekEnabled), _clsx4)),
            children: activityData === null || activityData === void 0 ? void 0 : activityData.subject
          })
        }), (activityData === null || activityData === void 0 ? void 0 : activityData.subtitle) && /*#__PURE__*/jsx(Text, {
          size: "xs",
          className: styles$g.activityHeaderSubtitle,
          children: activityData === null || activityData === void 0 ? void 0 : activityData.subtitle
        }), extended && (activityData === null || activityData === void 0 ? void 0 : activityData.extraSubtitle)]
      })
    })
  });
};

var css_248z$d = ".detailsFooter-module_footerContainer__wpcGK {\n  position: sticky;\n  width: 100%;\n  min-height: 72px;\n  padding: 0 24px;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  height: 72px;\n  background: rgb(2, 0, 36);\n  background: linear-gradient(90deg, var(--bloobirds) 0%, var(--gradientBloobirds) 100%);\n  border-bottom-left-radius: 8px;\n}\n\n.detailsFooter-module_footerContainer__wpcGK > button {\n  flex: 1;\n  border: none;\n}\n\n.detailsFooter-module_footerContainer__wpcGK > button:hover {\n  background-color: var(--lighterGray);\n}\n\n.detailsFooter-module_footerContainer__wpcGK > button > svg {\n  margin-right: 6px;\n}\n\n.detailsFooter-module_multipleButtons__eFy9Y {\n  justify-content: space-between;\n}\n";
var styles$d = {"footerContainer":"detailsFooter-module_footerContainer__wpcGK","multipleButtons":"detailsFooter-module_multipleButtons__eFy9Y"};
styleInject(css_248z$d);

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DetailsFooter = function DetailsFooter(_ref) {
  var children = _ref.children;
  var multipleButtons = React.Children.count(children) > 1;
  return /*#__PURE__*/jsx("div", {
    className: clsx(styles$d.footerContainer, _defineProperty$c({}, styles$d.multipleButtons, multipleButtons)),
    children: children
  });
};

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useEmailThreadActivities = function useEmailThreadActivities(threadId, accountId) {
  var _injectReferencesSear, _data$data;
  var fetchActivities = function fetchActivities() {
    var _query;
    return api.post('/bobjects/' + accountId + '/Activity/search', {
      //TODO: Add columns in query
      query: (_query = {}, _defineProperty$b(_query, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, [ACTIVITY_TYPES_VALUES_LOGIC_ROLE.EMAIL]), _defineProperty$b(_query, ACTIVITY_FIELDS_LOGIC_ROLE.EMAIL_THREAD_ID, threadId), _query),
      page: 0,
      formFields: true,
      pageSize: 30,
      injectReferences: true,
      sort: [{
        field: ACTIVITY_FIELDS_LOGIC_ROLE.TIME,
        direction: 'DESC'
      }]
    });
  };
  var _useSWR = useSWR(accountId && threadId && "/emailThreadActivities/".concat(threadId), fetchActivities),
    data = _useSWR.data;
  return {
    data: data,
    activities: data && ((_injectReferencesSear = injectReferencesSearchProcess(data === null || data === void 0 ? void 0 : data.data)) === null || _injectReferencesSear === void 0 ? void 0 : _injectReferencesSear.contents),
    total: data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.totalMatching
  };
};

var css_248z$c = ".emailThreadDetail-module_container__qYDfL {\n  padding-top: 4px;\n  height: 100%;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: column;\n}\n\n.emailThreadDetail-module_emailDetail_container__x8ay- {\n  margin-top: 2px;\n  height: 93%;\n  overflow: auto;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n.emailThreadDetail-module_loading__YieT7 {\n  display: flex;\n  justify-content: center;\n}\n\n.emailThreadDetail-module_htmlBody__mhg2P {\n  padding: 10px 20px;\n}\n\n.emailThreadDetail-module_htmlBody__mhg2P > * {\n  font-size: 10px;\n}\n\n.emailThreadDetail-module_openedClickedElement__W-ltS {\n  margin-top: 8px;\n}\n\n.emailThreadDetail-module__text_message__c-mNg {\n  overflow: auto;\n  overscroll-behavior-y: contain;\n}\n\n.emailThreadDetail-module_htmlBody__mhg2P ul {\n  margin-top: 4px;\n  list-style-type: disc;\n  margin-left: 15px;\n}\n\n.emailThreadDetail-module_htmlBody__mhg2P ol {\n  margin-top: 4px;\n  list-style-type: decimal;\n  margin-left: 15px;\n}\n\n.emailThreadDetail-module_htmlBody__mhg2P ul ul, .emailThreadDetail-module_htmlBody__mhg2P ol ul {\n  list-style-type: circle;\n  margin-left: 15px;\n}\n\n.emailThreadDetail-module_htmlBody__mhg2P ol ol, .emailThreadDetail-module_htmlBody__mhg2P ul ol {\n  list-style-type: lower-latin;\n  margin-left: 15px;\n}\n";
var styles$c = {"container":"emailThreadDetail-module_container__qYDfL","emailDetail_container":"emailThreadDetail-module_emailDetail_container__x8ay-","loading":"emailThreadDetail-module_loading__YieT7","htmlBody":"emailThreadDetail-module_htmlBody__mhg2P","openedClickedElement":"emailThreadDetail-module_openedClickedElement__W-ltS","_text_message":"emailThreadDetail-module__text_message__c-mNg"};
styleInject(css_248z$c);

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function LightAttachmentList(_ref) {
  var files = _ref.files,
    betterAttachments = _ref.betterAttachments;
  var listClasses = clsx(styles$f.list, _defineProperty$a({}, styles$f.wrappedList, files.length > 5));
  return /*#__PURE__*/jsx("div", {
    className: listClasses,
    role: "list",
    children: betterAttachments ? betterAttachments.map(function (file) {
      return !!file && /*#__PURE__*/jsx(LightAttachmentItem, {
        name: file.name,
        url: file.url,
        id: file.id
      }, file.id);
    }) : files.map(function (file) {
      return !!file && /*#__PURE__*/jsx(LightAttachmentItem, {
        name: file
      }, file);
    })
  });
}

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }
function _regeneratorRuntime$2() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime$2 = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof$2(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$9(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator$2(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$6(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$6(arr); }
function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$6(); }
function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }
function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$6(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }
var DetailedActivity$3 = function DetailedActivity(_ref) {
  var activity = _ref.activity;
  var activityBody = getValueFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MESSAGE_BODY);
  var cleanedHtmlString = activityBody === null || activityBody === void 0 ? void 0 : activityBody.replace(/<style>[\s\S]*?<\/style>/g, '');
  var isHtmlMessage = activityBody && isHtml(activityBody);
  var activityAttachedFiles = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.ATTACHED_FILES);
  var activityAttachments = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.ATTACHMENTS);
  var ref = useRef();
  var parsedAttachedFiles = activityAttachedFiles && JSON.parse(activityAttachedFiles);
  var parsedAttachments = activityAttachments && JSON.parse(activityAttachments);
  return /*#__PURE__*/jsxs("div", {
    className: styles$c.htmlBody,
    children: [isHtmlMessage ? /*#__PURE__*/jsx("div", {
      ref: ref,
      dangerouslySetInnerHTML: {
        __html: parseEmailPixels(cleanedHtmlString)
      }
    }) : /*#__PURE__*/jsx("div", {
      className: clsx(styles$c._text_message, {}),
      children: /*#__PURE__*/jsx(Text, {
        size: "xs",
        children: activityBody
      })
    }), parsedAttachedFiles && (parsedAttachedFiles === null || parsedAttachedFiles === void 0 ? void 0 : parsedAttachedFiles.length) !== 0 && /*#__PURE__*/jsx(LightAttachmentList, {
      files: parsedAttachedFiles,
      betterAttachments: parsedAttachments
    }), /*#__PURE__*/jsx("div", {
      className: styles$c.openedClickedElement,
      children: /*#__PURE__*/jsx(OpenClickedStatistics, {
        bobject: activity,
        size: "small"
      })
    })]
  });
};
var EmailThreadDetail = function EmailThreadDetail(_ref2) {
  var _activity$id3, _getFieldByLogicRole, _getFieldByLogicRole2, _getFieldByLogicRole3, _emailMetadata$from, _emailMetadata$from$, _emailMetadata$to, _emailMetadata$cc, _getFieldByLogicRole4;
  var activity = _ref2.activity,
    emailThreadId = _ref2.emailThreadId,
    accountId = _ref2.accountId,
    dataModel = _ref2.dataModel,
    _ref2$visibleFooter = _ref2.visibleFooter,
    visibleFooter = _ref2$visibleFooter === void 0 ? true : _ref2$visibleFooter,
    _ref2$actionsDisabled = _ref2.actionsDisabled,
    actionsDisabled = _ref2$actionsDisabled === void 0 ? false : _ref2$actionsDisabled,
    userId = _ref2.userId;
  var activityId = activity === null || activity === void 0 ? void 0 : activity.id;
  var _useState = useState([activityId]),
    _useState2 = _slicedToArray$6(_useState, 2),
    selectedActivities = _useState2[0],
    setSelectedActivities = _useState2[1];
  var _useEmailThreadActivi = useEmailThreadActivities(emailThreadId, accountId),
    activities = _useEmailThreadActivi.activities;
  var handleClickRow = function handleClickRow(activity) {
    if (selectedActivities !== null && selectedActivities !== void 0 && selectedActivities.find(function (act) {
      var _activity$id;
      return (act === null || act === void 0 ? void 0 : act.value) === (activity === null || activity === void 0 ? void 0 : (_activity$id = activity.id) === null || _activity$id === void 0 ? void 0 : _activity$id.value);
    })) {
      setSelectedActivities(selectedActivities === null || selectedActivities === void 0 ? void 0 : selectedActivities.filter(function (act) {
        var _activity$id2;
        return (act === null || act === void 0 ? void 0 : act.value) !== (activity === null || activity === void 0 ? void 0 : (_activity$id2 = activity.id) === null || _activity$id2 === void 0 ? void 0 : _activity$id2.value);
      }));
    } else {
      setSelectedActivities([].concat(_toConsumableArray(selectedActivities), [activity === null || activity === void 0 ? void 0 : activity.id]));
    }
  };
  useEffect(function () {
    setSelectedActivities([activity === null || activity === void 0 ? void 0 : activity.id]);
  }, [activity === null || activity === void 0 ? void 0 : (_activity$id3 = activity.id) === null || _activity$id3 === void 0 ? void 0 : _activity$id3.value]);
  var activitiesToRender = emailThreadId ? activities : [activity];
  var setEmailVariablesValue = useBaseSetEmailVariablesValues();
  var _useMinimizableModals = useMinimizableModals(),
    openMinimizableModal = _useMinimizableModals.openMinimizableModal;
  var activityCompany = (_getFieldByLogicRole = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.COMPANY)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.referencedBobject;
  var activityLead = (_getFieldByLogicRole2 = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.LEAD)) === null || _getFieldByLogicRole2 === void 0 ? void 0 : _getFieldByLogicRole2.referencedBobject;
  var activityOpportunity = (_getFieldByLogicRole3 = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.OPPORTUNITY)) === null || _getFieldByLogicRole3 === void 0 ? void 0 : _getFieldByLogicRole3.referencedBobject;
  var emailMetadataString = getValueFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.EMAIL_METADATA);
  var emailMetadata = emailMetadataString ? JSON.parse(emailMetadataString) : {};
  var emailToArray = !!emailMetadata && [(_emailMetadata$from = emailMetadata.from) === null || _emailMetadata$from === void 0 ? void 0 : (_emailMetadata$from$ = _emailMetadata$from[0]) === null || _emailMetadata$from$ === void 0 ? void 0 : _emailMetadata$from$.email].concat((_emailMetadata$to = emailMetadata.to) === null || _emailMetadata$to === void 0 ? void 0 : _emailMetadata$to.map(function (e) {
    return e.email;
  })).filter(Boolean);
  var emailCcArray = !!emailMetadata && ((_emailMetadata$cc = emailMetadata.cc) === null || _emailMetadata$cc === void 0 ? void 0 : _emailMetadata$cc.map(function (e) {
    return e.email;
  }));
  var activityDirection = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.DIRECTION);
  var handleOpenEmailModal = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator$2( /*#__PURE__*/_regeneratorRuntime$2().mark(function _callee(event, emailTo, emailCc) {
      var templateSubject;
      return _regeneratorRuntime$2().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              setEmailVariablesValue({
                company: activityCompany,
                lead: activityLead,
                opportunity: activityOpportunity
              });
              templateSubject = getValueFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MESSAGE_SUBJECT, true);
              openMinimizableModal({
                type: 'email',
                title: removeHtmlTags(templateSubject),
                data: _objectSpread$6(_objectSpread$6({
                  template: {
                    body: '',
                    subject: templateSubject
                  },
                  mode: EMAIL_MODE.REPLY,
                  activity: activity,
                  company: activityCompany,
                  lead: activityLead,
                  pageBobjectType: activityLead ? BobjectTypes.Lead : BobjectTypes.Company
                }, emailTo ? {
                  defaultToEmail: emailTo
                } : {}), emailCc ? {
                  defaultCcEmail: emailCc
                } : {}),
                onSave: function onSave() {
                  window.dispatchEvent(new CustomEvent(MessagesEvents.ActiveBobjectUpdated, {
                    detail: {
                      type: BobjectTypes.Activity
                    }
                  }));
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleOpenEmailModal(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var referenceBobject = getReferencedBobject(activity);
  var assignee = ((_getFieldByLogicRole4 = getFieldByLogicRole(referenceBobject, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO
  // @ts-ignore
  )) === null || _getFieldByLogicRole4 === void 0 ? void 0 : _getFieldByLogicRole4.value) || (referenceBobject === null || referenceBobject === void 0 ? void 0 : referenceBobject.assignedTo);
  var assignedToActiveUser = assignee === userId;
  return /*#__PURE__*/jsxs("div", {
    className: styles$c.container,
    children: [/*#__PURE__*/jsx("div", {
      className: styles$c.emailDetail_container,
      children: !activitiesToRender ? /*#__PURE__*/jsx("div", {
        className: styles$c.loading,
        children: /*#__PURE__*/jsx(Spinner, {
          name: "loadingCircle"
        })
      }) : /*#__PURE__*/jsx(Timeline, {
        size: "small",
        children: activitiesToRender === null || activitiesToRender === void 0 ? void 0 : activitiesToRender.map(function (activity, index) {
          var _activity$id4, _activity$id5;
          var isSelected = selectedActivities === null || selectedActivities === void 0 ? void 0 : selectedActivities.map(function (act) {
            return act === null || act === void 0 ? void 0 : act.value;
          }).includes(activity === null || activity === void 0 ? void 0 : (_activity$id4 = activity.id) === null || _activity$id4 === void 0 ? void 0 : _activity$id4.value);
          return /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(ActivityTimelineItem, {
              activity: activity,
              onClick: handleClickRow,
              startDisplayDivider: (activities === null || activities === void 0 ? void 0 : activities.length) > 1 && index !== 0,
              endDisplayDivider: (activities === null || activities === void 0 ? void 0 : activities.length) > 1 && index + 1 !== (activities === null || activities === void 0 ? void 0 : activities.length),
              activeHover: !isSelected,
              extended: true,
              dataModel: dataModel,
              alternativeDescription: true
            }, activity === null || activity === void 0 ? void 0 : (_activity$id5 = activity.id) === null || _activity$id5 === void 0 ? void 0 : _activity$id5.value), (selectedActivities === null || selectedActivities === void 0 ? void 0 : selectedActivities.find(function (act) {
              var _activity$id6;
              return (act === null || act === void 0 ? void 0 : act.value) === (activity === null || activity === void 0 ? void 0 : (_activity$id6 = activity.id) === null || _activity$id6 === void 0 ? void 0 : _activity$id6.value);
            })) && /*#__PURE__*/jsx(DetailedActivity$3, {
              activity: activity
            })]
          });
        })
      })
    }), visibleFooter && /*#__PURE__*/jsxs(DetailsFooter, {
      children: [activityDirection === ACTIVITY_DIRECTION.INCOMING && /*#__PURE__*/jsxs(Button, {
        variant: "secondary",
        onClick: function onClick(e) {
          return handleOpenEmailModal(e, emailToArray, emailCcArray);
        },
        disabled: actionsDisabled && !assignedToActiveUser,
        children: [/*#__PURE__*/jsx(Icon, {
          name: "replyAll",
          size: 14
        }), "Reply all"]
      }), /*#__PURE__*/jsxs(Button, {
        variant: "secondary",
        onClick: function onClick(e) {
          return handleOpenEmailModal(e, activityDirection === ACTIVITY_DIRECTION.INCOMING || emailToArray && (emailToArray === null || emailToArray === void 0 ? void 0 : emailToArray.length) === 0 ? undefined : emailToArray, activityDirection === ACTIVITY_DIRECTION.INCOMING || emailCcArray && (emailCcArray === null || emailCcArray === void 0 ? void 0 : emailCcArray.length) === 0 ? undefined : emailCcArray);
        },
        disabled: actionsDisabled && !assignedToActiveUser,
        children: [/*#__PURE__*/jsx(Icon, {
          name: activityDirection === ACTIVITY_DIRECTION.INCOMING ? 'reply' : 'mail',
          size: 14
        }), activityDirection === ACTIVITY_DIRECTION.INCOMING ? 'Reply' : 'Send another']
      })]
    })]
  });
};

var css_248z$b = ".callDetail-module_container__WCHaU {\n  padding-top: 4px;\n  height: 100%;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: column;\n}\n\n.callDetail-module_htmlBody__Ctm2- {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.callDetail-module_htmlBody__Ctm2- > * {\n  font-size: 10px;\n}\n\n.callDetail-module_callInfoWrapper__UET4s {\n  padding: 6px 12px 45px 14px;\n}\n\n.callDetail-module_loading__vTvci {\n  margin: auto;\n  width: 90%;\n  height: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.callDetail-module_noRecordingText__QJ3oB {\n  font-size: 16px !important;\n  margin: 8px 0;\n}\n\n.callDetail-module_header__coFJE {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  justify-content: space-between;\n}\n\n.callDetail-module_badge__ai1nN {\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 8px;\n}\n\n.callDetail-module_headerLeft__6V-U- {\n  display: flex;\n  align-items: center;\n  max-width: 240px;\n  overflow: hidden;\n}\n\n.callDetail-module_headerLeft__6V-U- > p {\n  margin-right: 0.3em;\n  display: flex;\n}\n\n.callDetail-module_headerText__wBp9y {\n  display: flex;\n  flex-direction: column;\n}\n\n.callDetail-module_headerText__wBp9y > p:first-child {\n  margin-right: 0.3em;\n}\n\n.callDetail-module_reportResultButton__gIeuq {\n  display: block;\n  color: var(--melon);\n  white-space: nowrap;\n  max-width: 290px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  border: none;\n}\n\n.callDetail-module_disabledButton__0vn3z {\n  color: var(--softCondition);\n}\n\n.callDetail-module_reportResultButton__gIeuq > svg {\n  margin-bottom: 1px;\n}\n";
var styles$b = {"container":"callDetail-module_container__WCHaU","htmlBody":"callDetail-module_htmlBody__Ctm2-","callInfoWrapper":"callDetail-module_callInfoWrapper__UET4s","loading":"callDetail-module_loading__vTvci","noRecordingText":"callDetail-module_noRecordingText__QJ3oB","header":"callDetail-module_header__coFJE","badge":"callDetail-module_badge__ai1nN","headerLeft":"callDetail-module_headerLeft__6V-U-","headerText":"callDetail-module_headerText__wBp9y","reportResultButton":"callDetail-module_reportResultButton__gIeuq","disabledButton":"callDetail-module_disabledButton__0vn3z"};
styleInject(css_248z$b);

var css_248z$a = ".callSoundWave-module_speedControls__pmgww{\n  display: flex;\n  align-items: center;\n  margin-left: 34px;\n  width: 75px;\n  justify-content: space-between;\n}\n\n.callSoundWave-module_speedControls__pmgww > *{\n  margin-right: 8px;\n}\n\n.callSoundWave-module_controls__nI8hu{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.callSoundWave-module_loader__HCab5{\n  position: relative;\n  left:130px;\n  bottom: 78px;\n  margin-bottom: -24px;\n}\n";
var styles$a = {"speedControls":"callSoundWave-module_speedControls__pmgww","controls":"callSoundWave-module_controls__nI8hu","loader":"callSoundWave-module_loader__HCab5"};
styleInject(css_248z$a);

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime$1() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime$1 = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof$1(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator$1(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$5(); }
function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }
function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$5(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }
var CallSoundWave = function CallSoundWave(_ref) {
  var audioSource = _ref.audioSource;
  var waveRef = useRef();
  var _useState = useState(true),
    _useState2 = _slicedToArray$5(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$5(_useState3, 2),
    isPlaying = _useState4[0],
    setIsPlaying = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray$5(_useState5, 2),
    audio = _useState6[0],
    setAudio = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray$5(_useState7, 2),
    url = _useState8[0],
    setUrl = _useState8[1];
  //const [playbackSpeed, setPlaybackSpeed] = useState(1);

  var buttonProps = isPlaying ? {
    name: 'pause',
    onClick: function onClick() {
      var _waveRef$current;
      setIsPlaying(false);
      // @ts-ignore
      waveRef === null || waveRef === void 0 ? void 0 : (_waveRef$current = waveRef.current) === null || _waveRef$current === void 0 ? void 0 : _waveRef$current.pause();
    }
  } : {
    name: 'play',
    onClick: function onClick() {
      var _waveRef$current2;
      setIsPlaying(true);
      // @ts-ignore
      waveRef === null || waveRef === void 0 ? void 0 : (_waveRef$current2 = waveRef.current) === null || _waveRef$current2 === void 0 ? void 0 : _waveRef$current2.play();
    }
  };

  /*function handleIncreasePlaybackSpeed(boo) {
    let speed = playbackSpeed;
    switch (speed) {
      case 0.5:
        speed = boo ? 1 : 0.5;
        break;
      case 1:
        speed = boo ? 1.5 : 0.5;
        break;
      case 1.5:
        speed = boo ? 2 : 1;
        break;
      case 2:
        speed = boo ? 2 : 1.5;
        break;
    }
    waveRef.current.setPlaybackRate(speed);
    setPlaybackSpeed(speed);
  }*/

  useEffect(function () {
    var _waveRef$current4, _waveRef$current4$han, _waveRef$current6, _waveRef$current6$han;
    if (waveRef.current) {
      var _waveRef$current3;
      // @ts-ignore
      waveRef === null || waveRef === void 0 ? void 0 : (_waveRef$current3 = waveRef.current) === null || _waveRef$current3 === void 0 ? void 0 : _waveRef$current3.destroy();
      setIsLoading(true);
    }
    waveRef.current = WaveSurfer.create({
      container: '#waveform',
      waveColor: '#94A5B4',
      progressColor: 'black',
      barWidth: 3
    });
    // @ts-ignore
    if (!((_waveRef$current4 = waveRef.current) !== null && _waveRef$current4 !== void 0 && (_waveRef$current4$han = _waveRef$current4.handlers) !== null && _waveRef$current4$han !== void 0 && _waveRef$current4$han.ready)) {
      var _waveRef$current5;
      // @ts-ignore
      (_waveRef$current5 = waveRef.current) === null || _waveRef$current5 === void 0 ? void 0 : _waveRef$current5.on('ready', function () {
        setIsLoading(false);
      });
    }
    // @ts-ignore
    if (!((_waveRef$current6 = waveRef.current) !== null && _waveRef$current6 !== void 0 && (_waveRef$current6$han = _waveRef$current6.handlers) !== null && _waveRef$current6$han !== void 0 && _waveRef$current6$han.error)) {
      var _waveRef$current7;
      // @ts-ignore
      (_waveRef$current7 = waveRef.current) === null || _waveRef$current7 === void 0 ? void 0 : _waveRef$current7.on('error', function (e) {
        console.warn(e);
      });
    }
    var getSignedCallRecordingUrl = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee() {
        var oldRecordingRegex, callSid, itsADeprecatedRecordingLink, signedUrl;
        return _regeneratorRuntime$1().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                oldRecordingRegex = /^(https:\/\/record-calls.bloobirds.com\/)(.{34})/g;
                callSid = audioSource;
                itsADeprecatedRecordingLink = audioSource.match(oldRecordingRegex);
                if (!(!itsADeprecatedRecordingLink && isUrl(audioSource))) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", audioSource);
              case 5:
                if (audioSource && itsADeprecatedRecordingLink) {
                  callSid = audioSource.split('/').at(-1);
                } else {
                  callSid = audioSource.split('/')[1];
                }
                _context.next = 8;
                return api.get("/calls/whiteLabel/calls/".concat(callSid, "/recording"));
              case 8:
                signedUrl = _context.sent;
                if (!(signedUrl.status === 200)) {
                  _context.next = 13;
                  break;
                }
                return _context.abrupt("return", signedUrl.data.url);
              case 13:
                throw new Error('Failed to get signed url');
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function getSignedCallRecordingUrl() {
        return _ref2.apply(this, arguments);
      };
    }();
    getSignedCallRecordingUrl().then(function (url) {
      setUrl(url);
    });
    return function () {
      // @ts-ignore
      waveRef.current.destroy();
    };
  }, [audioSource]);
  useEffect(function () {
    if (url) {
      fetch(url).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        return setAudio(blob);
      });
    }
  }, [url, audioSource]);
  useEffect(function () {
    if (audio && (audio === null || audio === void 0 ? void 0 : audio.size) !== 0) {
      var _waveRef$current8;
      // @ts-ignore
      (_waveRef$current8 = waveRef.current) === null || _waveRef$current8 === void 0 ? void 0 : _waveRef$current8.loadBlob(audio);
    }
  }, [audio]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      id: "waveform",
      style: {
        display: isLoading ? 'hidden' : ''
      }
    }), isLoading && /*#__PURE__*/jsx("div", {
      className: styles$a.loader,
      children: /*#__PURE__*/jsx(Spinner, {
        name: "loadingCircle"
      })
    }), /*#__PURE__*/jsx("div", {
      className: styles$a.controls,
      children: /*#__PURE__*/jsx(IconButton, _objectSpread$5(_objectSpread$5({}, buttonProps), {}, {
        size: 36
      }))
    })]
  });
};

var css_248z$9 = ".expandedBoxSection-module_multibox__EsTkD {\n  margin: 0 4px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.expandedBoxSection-module_simple__yCNe3 {\n  margin: 0 8px;\n}\n\n\n.expandedBoxSection-module_separator__II8CF {\n  margin: 8px 0 12px;\n  display: flex;\n  align-self: center;\n  width: 100%;\n  height: 1px;\n  background-color: var(--verySoftPeanut);\n}\n";
var styles$9 = {"multibox":"expandedBoxSection-module_multibox__EsTkD","simple":"expandedBoxSection-module_simple__yCNe3","separator":"expandedBoxSection-module_separator__II8CF"};
styleInject(css_248z$9);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ExpandedBoxSection = function ExpandedBoxSection(_ref) {
  var children = _ref.children,
    grid = _ref.grid;
  var className = grid ? styles$9.multibox : styles$9.simple;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: styles$9.separator
    }), /*#__PURE__*/jsx("div", {
      className: className,
      children: React.Children.map(children, function (child) {
        if (grid) {
          return _objectSpread$4(_objectSpread$4({}, child), {}, {
            props: _objectSpread$4(_objectSpread$4({}, child.props), {}, {
              isSmallBlock: true
            })
          });
        } else {
          return child;
        }
      })
    })]
  });
};

var css_248z$8 = ".textBox-module_infoSectionHeader__2FL7F{\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.textBox-module_infoSectionText__Kdpp-{\n  overflow-wrap: break-word;\n}\n\n.textBox-module_html_message__cSlzx{\n  overflow-wrap: break-word;\n}\n\n.textBox-module_html_message__cSlzx > p {\n  font-size: 12px;\n}\n\n.textBox-module_html_message__cSlzx > ol,\n.textBox-module_html_message__cSlzx > ul {\n  padding-left: 24px !important;\n}\n\n.textBox-module_html_message__cSlzx > ol {\n  list-style: decimal !important;\n}\n\n.textBox-module_infoLine__3Thpj {\n  display: flex;\n  width: 100%;\n}\n\n.textBox-module_smallInfoSection__XEE7R{\n  width: 135px;\n  display: flex;\n  flex-direction: column;\n}\n\n.textBox-module_smallInfoSection__XEE7R:nth-child(-n+2){\n  margin-bottom: 12px;\n}\n\n.textBox-module_smallInfoSectionTitle__U-iU3{\n  width: 100%;\n  display: flex;\n}\n\n.textBox-module_smallInfoSectionTitle__U-iU3 > p{\n  margin-left: 4px;\n  align-self: center;\n}\n";
var styles$8 = {"infoSectionHeader":"textBox-module_infoSectionHeader__2FL7F","infoSectionText":"textBox-module_infoSectionText__Kdpp-","html_message":"textBox-module_html_message__cSlzx","infoLine":"textBox-module_infoLine__3Thpj","smallInfoSection":"textBox-module_smallInfoSection__XEE7R","smallInfoSectionTitle":"textBox-module_smallInfoSectionTitle__U-iU3"};
styleInject(css_248z$8);

var _excluded$1 = ["isSmallBlock"];
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TextInfoDisplay = function TextInfoDisplay(_ref) {
  var info = _ref.info;
  var isHTMLNote = isHtml(info);
  return isHTMLNote ? /*#__PURE__*/jsx("div", {
    className: styles$8.html_message,
    dangerouslySetInnerHTML: {
      __html: info
    }
  }) : /*#__PURE__*/jsx(Text, {
    className: styles$8.infoSectionText,
    size: "xs",
    children: info ? info : 'None'
  });
};
var InfoSection = function InfoSection(_ref2) {
  var icon = _ref2.icon,
    title = _ref2.title,
    info = _ref2.info;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$8.infoSectionHeader,
      children: [/*#__PURE__*/jsx(Icon, {
        name: icon,
        color: "bloobirds"
      }), /*#__PURE__*/jsx(Text, {
        size: "xs",
        weight: "heavy",
        children: title
      })]
    }), typeof info === 'string' || !info ? /*#__PURE__*/jsx(TextInfoDisplay, {
      info: info
    }) : info]
  });
};
var SmallInfoSection = function SmallInfoSection(_ref3) {
  var icon = _ref3.icon,
    title = _ref3.title,
    info = _ref3.info;
  return /*#__PURE__*/jsxs("div", {
    className: styles$8.smallInfoSection,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$8.smallInfoSectionTitle,
      children: [/*#__PURE__*/jsx(Icon, {
        name: icon,
        color: "bloobirds"
      }), /*#__PURE__*/jsx(Text, {
        size: "xs",
        weight: "heavy",
        children: title
      })]
    }), /*#__PURE__*/jsx(Text, {
      size: "xs",
      children: info ? info : 'None'
    })]
  });
};
var InfoBox = function InfoBox(_ref4) {
  var _ref4$isSmallBlock = _ref4.isSmallBlock,
    isSmallBlock = _ref4$isSmallBlock === void 0 ? false : _ref4$isSmallBlock,
    props = _objectWithoutProperties$1(_ref4, _excluded$1);
  switch (isSmallBlock) {
    case true:
      return /*#__PURE__*/jsx(SmallInfoSection, _objectSpread$3({}, props));
    default:
      return /*#__PURE__*/jsx(InfoSection, _objectSpread$3({}, props));
  }
};

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$4(); }
function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$4(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
var NoCallRecordingMessage = function NoCallRecordingMessage() {
  return /*#__PURE__*/jsx("div", {
    children: /*#__PURE__*/jsx(Text, {
      align: "center",
      className: styles$b.noRecordingText,
      children: "No recording available"
    })
  });
};
var DetailedActivity$2 = function DetailedActivity(_ref) {
  var _getTextFromLogicRole, _getTextFromLogicRole2;
  var activity = _ref.activity,
    dataModel = _ref.dataModel,
    userId = _ref.userId,
    actionsDisabled = _ref.actionsDisabled;
  var creationDate = (_getTextFromLogicRole = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CREATION_DATETIME)) === null || _getTextFromLogicRole === void 0 ? void 0 : (_getTextFromLogicRole2 = _getTextFromLogicRole.split('.')[0]) === null || _getTextFromLogicRole2 === void 0 ? void 0 : _getTextFromLogicRole2.toString();
  var parsedCreationDate = creationDate + ((creationDate === null || creationDate === void 0 ? void 0 : creationDate.slice(-1)) === 'Z' ? '' : 'Z');
  var creationDateTime = creationDate ? formatDate(new Date(parsedCreationDate), 'MMM dd yyyy, HH:mm') : '';
  var callDuration = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_DURATION);
  var result = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_RESULT);
  var callNote = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.NOTE);
  var audioSource = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_RECORD_URL);
  var SoundWave = useCallback(function () {
    return /*#__PURE__*/jsx(CallSoundWave, {
      audioSource: audioSource
    });
  }, [audioSource]);
  return /*#__PURE__*/jsxs("div", {
    className: styles$b.htmlBody,
    children: [/*#__PURE__*/jsx(ActivityTimelineItem, {
      activity: activity,
      startDisplayDivider: false,
      endDisplayDivider: false,
      activeHover: false,
      extended: true,
      alternativeDescription: true,
      dataModel: dataModel,
      userId: userId,
      actionsDisabled: actionsDisabled
    }), /*#__PURE__*/jsxs("div", {
      className: styles$b.callInfoWrapper,
      children: [audioSource ? /*#__PURE__*/jsx(SoundWave, {}) : /*#__PURE__*/jsx(NoCallRecordingMessage, {}), /*#__PURE__*/jsxs(ExpandedBoxSection, {
        grid: true,
        children: [/*#__PURE__*/jsx(InfoBox, {
          icon: "calendar",
          title: "Call date",
          info: creationDateTime
        }), /*#__PURE__*/jsx(InfoBox, {
          icon: "clock",
          title: "Call duration",
          info: callDuration ? new Date(callDuration * 1000).toISOString().substring(14, 19) : 'none'
        }), /*#__PURE__*/jsx(InfoBox, {
          icon: "phoneHang",
          title: "Call result",
          info: result
        })]
      }), /*#__PURE__*/jsx(ExpandedBoxSection, {
        children: /*#__PURE__*/jsx(InfoBox, {
          icon: "noteAction",
          title: "Note (internal)",
          info: callNote
        })
      })]
    })]
  });
};
var CallDetail = function CallDetail(_ref2) {
  var _getFieldByLogicRole;
  var activity = _ref2.activity,
    dataModel = _ref2.dataModel,
    _ref2$visibleFooter = _ref2.visibleFooter,
    visibleFooter = _ref2$visibleFooter === void 0 ? true : _ref2$visibleFooter,
    onSave = _ref2.onSave,
    _ref2$actionsDisabled = _ref2.actionsDisabled,
    actionsDisabled = _ref2$actionsDisabled === void 0 ? false : _ref2$actionsDisabled,
    userId = _ref2.userId;
  var reportResult = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALL_RESULT);
  var _useState = useState(false),
    _useState2 = _slicedToArray$4(_useState, 2),
    isOpenContactFlowModal = _useState2[0],
    setIsOpenContactFlowModal = _useState2[1];
  var _useState3 = useState(
    // @ts-ignore
    getReferencedBobject(activity)),
    _useState4 = _slicedToArray$4(_useState3, 2),
    referenceBobject = _useState4[0],
    setReferenceBobject = _useState4[1];
  var assignee = ((_getFieldByLogicRole = getFieldByLogicRole(referenceBobject, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.value) || (referenceBobject === null || referenceBobject === void 0 ? void 0 : referenceBobject.assignedTo);
  var assignedToActiveUser = assignee === userId;
  function handleClose() {
    setIsOpenContactFlowModal(false);
    onSave();
  }
  function handleOnClick() {
    var referencedBobject = getReferencedBobject(activity);
    if (!referencedBobject) getExtensionBobjectByIdFields(referencedBobject.id).then(function (_ref3) {
      var data = _ref3.data;
      return setReferenceBobject(data);
    });
    setIsOpenContactFlowModal(true);
  }
  return /*#__PURE__*/jsxs("div", {
    className: styles$b.container,
    children: [!activity ? /*#__PURE__*/jsx("div", {
      className: styles$b.loading,
      children: /*#__PURE__*/jsx(Spinner, {
        name: "loadingCircle"
      })
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(DetailedActivity$2, {
        activity: activity,
        dataModel: dataModel,
        userId: userId,
        actionsDisabled: actionsDisabled
      }), visibleFooter && /*#__PURE__*/jsx(DetailsFooter, {
        children: reportResult ? /*#__PURE__*/jsxs(Button, {
          variant: "primary",
          color: "verySoftMelon",
          className: clsx(styles$b.reportResultButton, _defineProperty$5({}, styles$b.disabledButton, actionsDisabled && !assignedToActiveUser)),
          onClick: handleOnClick,
          disabled: actionsDisabled && !assignedToActiveUser,
          children: [/*#__PURE__*/jsx(Icon, {
            name: "thumbsUp",
            size: 14,
            color: "melon"
          }), reportResult]
        }) : /*#__PURE__*/jsxs(Button, {
          variant: "secondary",
          onClick: handleOnClick,
          disabled: actionsDisabled && !assignedToActiveUser,
          children: [/*#__PURE__*/jsx(Icon, {
            name: "thumbsUp",
            size: 14
          }), "Report result"]
        })
      })]
    }), isOpenContactFlowModal && referenceBobject && /*#__PURE__*/jsx(ContactFlowModal, {
      handleClose: handleClose,
      activity: activity,
      dataModel: dataModel,
      referenceBobject: referenceBobject
    })]
  });
};

var css_248z$7 = ".inboundDetail-module_container__Utt6y {\n  padding-top: 4px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.inboundDetail-module_htmlBody__ec4p6 {\n  overflow: auto;\n}\n\n.inboundDetail-module_htmlBody__ec4p6 > * {\n  font-size: 10px;\n}\n\n.inboundDetail-module_inboundInfoWrapper__vOVce {\n  padding: 6px 14px 45px 18px;\n}\n\n.inboundDetail-module_infoBlock__l7E7O {\n  margin-bottom: 4px\n}\n\n.inboundDetail-module_infoBlockFieldName__cDIyk {\n  margin-bottom: 5px\n}\n\n.inboundDetail-module_loading__sIp-I {\n  margin: auto;\n  width: 90%;\n  height: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n";
var styles$7 = {"container":"inboundDetail-module_container__Utt6y","htmlBody":"inboundDetail-module_htmlBody__ec4p6","inboundInfoWrapper":"inboundDetail-module_inboundInfoWrapper__vOVce","infoBlock":"inboundDetail-module_infoBlock__l7E7O","infoBlockFieldName":"inboundDetail-module_infoBlockFieldName__cDIyk","loading":"inboundDetail-module_loading__sIp-I"};
styleInject(css_248z$7);

var InfoBlock = function InfoBlock(_ref) {
  var field = _ref.field,
    value = _ref.value;
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.infoBlock,
    children: [/*#__PURE__*/jsx(Text, {
      className: styles$7.infoBlockFieldName,
      size: "xs",
      color: "softPeanut",
      children: field
    }), /*#__PURE__*/jsx(Text, {
      size: "xs",
      children: value ? value : '-'
    })]
  });
};
var DetailedActivity$1 = function DetailedActivity(_ref2) {
  var activity = _ref2.activity,
    dataModel = _ref2.dataModel;
  var fields = dataModel === null || dataModel === void 0 ? void 0 : dataModel.getFieldsByBobjectType('Activity');
  var inboundFields = fields === null || fields === void 0 ? void 0 : fields.filter(function (field) {
    return field.inboundField;
  }).sort(function (a, b) {
    return a.ordering - b.ordering;
  });
  var fieldsToDisplay = inboundFields === null || inboundFields === void 0 ? void 0 : inboundFields.map(function (field) {
    var _getFieldById;
    return {
      fieldName: field === null || field === void 0 ? void 0 : field.name,
      value: (_getFieldById = getFieldById(activity, field === null || field === void 0 ? void 0 : field.id)) === null || _getFieldById === void 0 ? void 0 : _getFieldById.text
    };
  });
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.htmlBody,
    children: [/*#__PURE__*/jsx(ActivityTimelineItem, {
      activity: activity,
      startDisplayDivider: false,
      endDisplayDivider: false,
      extended: true,
      alternativeDescription: true,
      activeHover: false,
      dataModel: dataModel
    }), /*#__PURE__*/jsx("div", {
      className: styles$7.inboundInfoWrapper,
      children: fieldsToDisplay && (fieldsToDisplay === null || fieldsToDisplay === void 0 ? void 0 : fieldsToDisplay.map(function (_ref3) {
        var fieldName = _ref3.fieldName,
          value = _ref3.value;
        return /*#__PURE__*/jsx(InfoBlock, {
          field: fieldName,
          value: value
        }, fieldName);
      }))
    })]
  });
};
var InboundDetail = function InboundDetail(_ref4) {
  var activity = _ref4.activity,
    dataModel = _ref4.dataModel;
  return /*#__PURE__*/jsx("div", {
    className: styles$7.container,
    children: !activity ? /*#__PURE__*/jsx("div", {
      className: styles$7.loading,
      children: /*#__PURE__*/jsx(Spinner, {
        name: "loadingCircle"
      })
    }) : /*#__PURE__*/jsx(DetailedActivity$1, {
      activity: activity,
      dataModel: dataModel
    })
  });
};

var css_248z$6 = ".linkedInDetail-module_container__FKFyS {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n\n.linkedInDetail-module_activity_container__MLMcE {\n  margin-top: 2px;\n  height: 93%;\n  overflow: auto;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.linkedInDetail-module__messages_wrapper__SY7VI {\n  min-height: 0;\n  height: calc(100% - 46px);\n  overflow-y: overlay;\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: flex-end;\n  background-color: var(--lightBloobirds);\n  width: 100%;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.linkedInDetail-module__messages_wrapper__SY7VI > div {\n  height: 100%;\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.linkedInDetail-module__messages_wrapper__SY7VI > div > div {\n  overflow-y: overlay;\n  overflow-x: unset;\n}\n\n.linkedInDetail-module__reported_separator__kgdYu {\n  background-color: rgba(255, 255, 255, 0.4);\n  padding: 12px;\n  margin-bottom: 10px;\n}\n\n.linkedInDetail-module__date_separator__Jk1OI {\n  padding: 12px;\n}\n\n.linkedInDetail-module__message__AV8m- {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n  padding: 0 15px;\n}\n\n.linkedInDetail-module__message__AV8m- > p {\n  box-sizing: border-box;\n  max-width: 70%;\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.linkedInDetail-module__message_outgoing__Qy1DW {\n  justify-content: flex-end;\n}\n\n.linkedInDetail-module__message_outgoing__Qy1DW > p {\n  background-color: var(--verySoftBloobirds);\n}\n\n.linkedInDetail-module__message_incoming__7Ogin > p {\n  background-color: var(--white);\n}\n\n.linkedInDetail-module_loading__Qm4kl {\n  margin: auto;\n  width: 100%;\n  min-height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.linkedInDetail-module__conversation_wrapper__iKJES {\n  display: flex;\n  flex-direction: column-reverse;\n}\n";
var styles$6 = {"container":"linkedInDetail-module_container__FKFyS","activity_container":"linkedInDetail-module_activity_container__MLMcE","_messages_wrapper":"linkedInDetail-module__messages_wrapper__SY7VI","_reported_separator":"linkedInDetail-module__reported_separator__kgdYu","_date_separator":"linkedInDetail-module__date_separator__Jk1OI","_message":"linkedInDetail-module__message__AV8m-","_message_outgoing":"linkedInDetail-module__message_outgoing__Qy1DW","_message_incoming":"linkedInDetail-module__message_incoming__7Ogin","loading":"linkedInDetail-module_loading__Qm4kl","_conversation_wrapper":"linkedInDetail-module__conversation_wrapper__iKJES"};
styleInject(css_248z$6);

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3(); }
function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
var PAGE_SIZE = 10;
var useLinkedinThreads = function useLinkedinThreads(linkedinThread, accountId, leadId, reverse) {
  var _query, _response$data2, _response$data2$injec, _response$data3;
  var _useState = useState(1),
    _useState2 = _slicedToArray$3(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var fetchNextPage = function fetchNextPage() {
    setPage(page + 1);
  };

  // TODO: To be changed
  var query = (_query = {}, _defineProperty$4(_query, ACTIVITY_FIELDS_LOGIC_ROLE.LEAD, [leadId]), _defineProperty$4(_query, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, [ACTIVITY_TYPES_VALUES_LOGIC_ROLE.LINKEDIN]), _defineProperty$4(_query, ACTIVITY_FIELDS_LOGIC_ROLE.SOURCE, [DATA_SOURCES.CHROME_EXTENSION]), _defineProperty$4(_query, ACTIVITY_FIELDS_LOGIC_ROLE.LINKEDIN_THREAD, [linkedinThread]), _query);
  var response = useSWR("/bobjects/".concat(accountId, "/Activity/search/").concat(leadId, "/").concat(linkedinThread, "/").concat(page, "}"), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response, _response$data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api.post('/bobjects/' + accountId + '/Activity/search', {
              query: query,
              formFields: true,
              sort: [{
                field: ACTIVITY_FIELDS_LOGIC_ROLE.TIME,
                direction: reverse ? 'DESC' : 'ASC'
              }, {
                field: ACTIVITY_FIELDS_LOGIC_ROLE.LEAD,
                direction: 'DESC'
              }],
              page: 0,
              pageSize: page ? page * PAGE_SIZE : 100,
              injectReferences: true
            });
          case 2:
            response = _context.sent;
            if (!(response !== null && response !== void 0 && response.data)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", {
              injectedContents: injectReferencesSearchProcess(response === null || response === void 0 ? void 0 : response.data),
              totalMatching: (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.totalMatching
            });
          case 5:
            return _context.abrupt("return", null);
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), {
    use: [keepPreviousResponse]
  });
  return {
    items: response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$injec = _response$data2.injectedContents) === null || _response$data2$injec === void 0 ? void 0 : _response$data2$injec.contents,
    isLoading: !response,
    totalMatching: response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.totalMatching,
    fetchNextPage: fetchNextPage
  };
};

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var LinkedInDetailedActivity = function LinkedInDetailedActivity(_ref) {
  var _activity$id;
  var activity = _ref.activity,
    dataModel = _ref.dataModel,
    items = _ref.items,
    totalMatching = _ref.totalMatching,
    fetchNextPage = _ref.fetchNextPage,
    isLoading = _ref.isLoading;
  var ref = useRef();
  var hasNextPage = useMemo(function () {
    return !((items === null || items === void 0 ? void 0 : items.length) === totalMatching);
  }, [items === null || items === void 0 ? void 0 : items.length, totalMatching]);
  if (!items || isLoading) {
    return /*#__PURE__*/jsx("div", {
      className: styles$6.loading,
      children: /*#__PURE__*/jsx(Spinner, {
        name: "loadingCircle"
      })
    });
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ActivityTimelineItem, {
      activity: activity,
      startDisplayDivider: false,
      endDisplayDivider: false,
      extended: true,
      alternativeDescription: true,
      activeHover: false,
      dataModel: dataModel
    }, activity === null || activity === void 0 ? void 0 : (_activity$id = activity.id) === null || _activity$id === void 0 ? void 0 : _activity$id.value), /*#__PURE__*/jsx("div", {
      className: styles$6._messages_wrapper,
      id: "conversationContent",
      ref: ref,
      children: /*#__PURE__*/jsx(InfiniteScroll, {
        dataLength: items.length,
        hasMore: hasNextPage,
        next: fetchNextPage,
        inverse: true,
        height: "100%",
        scrollThreshold: 0.75,
        scrollableTarget: "conversationContent",
        loader: /*#__PURE__*/jsx("div", {
          className: styles$6.loading,
          children: /*#__PURE__*/jsx(Spinner, {
            name: "dots"
          })
        }),
        style: {
          display: 'flex',
          flexDirection: 'column-reverse'
        },
        children: /*#__PURE__*/jsx("div", {
          className: styles$6._conversation_wrapper,
          children: items.map(function (data) {
            var _data$id, _data$messageStatus, _data$messageDate, _data$messageDate2, _clsx;
            var messageText = getTextFromLogicRole(data, ACTIVITY_FIELDS_LOGIC_ROLE.MESSAGE_BODY);
            var messageDirection = getTextFromLogicRole(data, ACTIVITY_FIELDS_LOGIC_ROLE.DIRECTION);
            return /*#__PURE__*/jsx(Fragment, {
              children: /*#__PURE__*/jsxs("div", {
                children: [(data === null || data === void 0 ? void 0 : (_data$messageStatus = data.messageStatus) === null || _data$messageStatus === void 0 ? void 0 : _data$messageStatus.isFirstOfNotReported) && /*#__PURE__*/jsx("div", {
                  className: styles$6._reported_separator,
                  children: /*#__PURE__*/jsx(Text, {
                    color: "softPeanut",
                    size: "s",
                    align: "center",
                    weight: "bold",
                    uppercase: true,
                    children: "Not reported messages"
                  })
                }), (data === null || data === void 0 ? void 0 : (_data$messageDate = data.messageDate) === null || _data$messageDate === void 0 ? void 0 : _data$messageDate.isFirstOfDay) && /*#__PURE__*/jsx("div", {
                  className: styles$6._date_separator,
                  children: /*#__PURE__*/jsx(Text, {
                    color: "softPeanut",
                    size: "s",
                    align: "center",
                    children: data === null || data === void 0 ? void 0 : (_data$messageDate2 = data.messageDate) === null || _data$messageDate2 === void 0 ? void 0 : _data$messageDate2.formattedDate
                  })
                }), /*#__PURE__*/jsx("div", {
                  className: clsx(styles$6._message, (_clsx = {}, _defineProperty$3(_clsx, styles$6._message_incoming, messageDirection === ACTIVITY_DIRECTION.INCOMING), _defineProperty$3(_clsx, styles$6._message_outgoing, messageDirection === ACTIVITY_DIRECTION.OUTGOING), _clsx)),
                  children: /*#__PURE__*/jsx(Text, {
                    size: "s",
                    children: messageText === 'undefined' ? 'Message could not be parsed into Bloobirds' : messageText
                  })
                })]
              }, data === null || data === void 0 ? void 0 : (_data$id = data.id) === null || _data$id === void 0 ? void 0 : _data$id.value)
            });
          })
        })
      })
    })]
  });
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var addConversationGrouping = function addConversationGrouping(items) {
  return items.map(function (item, index) {
    var _getFieldByLogicRole, _getFieldByLogicRole2;
    var date = new Date(getValueFromLogicRole(item, ACTIVITY_FIELDS_LOGIC_ROLE.TIME));
    var reportedStatus = (_getFieldByLogicRole = getFieldByLogicRole(item, ACTIVITY_FIELDS_LOGIC_ROLE.REPORTED)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.valueLogicRole;
    var previous = items[index - 1];
    var previousItemDate = previous && new Date(getValueFromLogicRole(previous, ACTIVITY_FIELDS_LOGIC_ROLE.TIME));
    var previousItemReportedStatus = previous && ((_getFieldByLogicRole2 = getFieldByLogicRole(previous, ACTIVITY_FIELDS_LOGIC_ROLE.REPORTED)) === null || _getFieldByLogicRole2 === void 0 ? void 0 : _getFieldByLogicRole2.valueLogicRole);
    var formattedDay = isValid(date) ? formatDate(date, 'MMM do, yyyy') : '';
    var dateDay = isValid(date) ? parse(formattedDay, 'MMM do, yyyy', new Date()) : '';
    var hashDate = getDateTimestampString(date);
    var isReported = function isReported(value) {
      return value === REPORTED_VALUES_LOGIC_ROLE.YES;
    };
    return _objectSpread$2(_objectSpread$2({}, item), {}, {
      messageDate: {
        isFirstOfDay: !previousItemDate || !isSameDay(date, previousItemDate),
        day: dateDay,
        formattedDate: formattedDay,
        prefix: generateDatePrefix(date, true),
        hashDate: hashDate
      },
      messageStatus: {
        isFirstOfNotReported: isReported(previousItemReportedStatus) && !isReported(reportedStatus) || !previous && !isReported(reportedStatus),
        isReported: isReported(reportedStatus)
      }
    });
  });
};
var LinkedInDetail = function LinkedInDetail(_ref) {
  var _getFieldByLogicRole3;
  var activity = _ref.activity,
    accountId = _ref.accountId,
    dataModel = _ref.dataModel,
    _ref$visibleFooter = _ref.visibleFooter,
    visibleFooter = _ref$visibleFooter === void 0 ? true : _ref$visibleFooter,
    _ref$actionsDisabled = _ref.actionsDisabled,
    actionsDisabled = _ref$actionsDisabled === void 0 ? false : _ref$actionsDisabled,
    userId = _ref.userId;
  var linkedInThreadId = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.LINKEDIN_THREAD);
  var leadId = getValueFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.LEAD);
  var _useLinkedinThreads = useLinkedinThreads(linkedInThreadId, accountId, leadId, true),
    items = _useLinkedinThreads.items,
    isLoading = _useLinkedinThreads.isLoading,
    fetchNextPage = _useLinkedinThreads.fetchNextPage,
    totalMatching = _useLinkedinThreads.totalMatching;
  var aggregatedConversations = items && addConversationGrouping(items);
  var goToLinkedinConversationPage = function goToLinkedinConversationPage() {
    window.open("https://www.linkedin.com/".concat(linkedInThreadId), '_blank');
  };
  var referenceBobject = getReferencedBobject(activity);
  var assignee = ((_getFieldByLogicRole3 = getFieldByLogicRole(referenceBobject, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO
  // @ts-ignore
  )) === null || _getFieldByLogicRole3 === void 0 ? void 0 : _getFieldByLogicRole3.value) || (referenceBobject === null || referenceBobject === void 0 ? void 0 : referenceBobject.assignedTo);
  var assignedToActiveUser = assignee === userId;
  return /*#__PURE__*/jsxs("div", {
    className: styles$6.container,
    children: [/*#__PURE__*/jsx("div", {
      className: styles$6.activity_container,
      children: /*#__PURE__*/jsx(LinkedInDetailedActivity, {
        activity: activity,
        dataModel: dataModel,
        items: aggregatedConversations,
        isLoading: isLoading,
        totalMatching: totalMatching,
        fetchNextPage: fetchNextPage
      })
    }), visibleFooter && /*#__PURE__*/jsx(DetailsFooter, {
      children: /*#__PURE__*/jsxs(Button, {
        variant: "secondary",
        onClick: goToLinkedinConversationPage,
        disabled: actionsDisabled && !assignedToActiveUser,
        children: [/*#__PURE__*/jsx(Icon, {
          name: "linkedin",
          size: 14
        }), "Reply"]
      })
    })]
  });
};

var css_248z$5 = "\n.inviteeCard-module_invitees_container__euiVt {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.inviteeCard-module_invitees__UpD6i {\n  display: flex;\n  width: 100%;\n}\n\n.inviteeCard-module__invitee_card__7EAJk {\n  display: flex;\n  align-items: center;\n  margin: 6px 0;\n  width: 100%;\n}\n\n.inviteeCard-module__invitee_info__19zs- {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-left: 12px;\n}\n\n.inviteeCard-module__invitee_info__19zs- > p {\n  width: 95%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.inviteeCard-module_showMore__LhjVk {\n  margin-top: 8px;\n  cursor: pointer;\n}\n";
var styles$5 = {"invitees_container":"inviteeCard-module_invitees_container__euiVt","invitees":"inviteeCard-module_invitees__UpD6i","_invitee_card":"inviteeCard-module__invitee_card__7EAJk","_invitee_info":"inviteeCard-module__invitee_info__19zs-","showMore":"inviteeCard-module_showMore__LhjVk"};
styleInject(css_248z$5);

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }
function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }
var randomColors = ['bloobirds', 'softPeanut', 'verySoftTangerine', 'softTangerine', 'verySoftTomato', 'softTomato', 'softBanana', 'verySoftBanana', 'verySoftMelon', 'softMelon', 'lightBloobirds', 'verySoftBloobirds', 'verySoftPurple', 'lightPurple', 'verySoftPeanut', 'lightPeanut', 'lighterGray', 'gray'];

/**
 * This component is duplicated in meeting component in components folder
 * so we should copy for now from one place to another
 * @param invitee
 * @param handleRemoveInvitee
 * @param readOnly
 * @param width
 * @param shouldShowStatus
 * @constructor
 */
function InviteeCard(_ref) {
  var _invitee$email, _invitee$name;
  var invitee = _ref.invitee,
    handleRemoveInvitee = _ref.handleRemoveInvitee,
    readOnly = _ref.readOnly,
    width = _ref.width,
    shouldShowStatus = _ref.shouldShowStatus;
  var _useState = useState(randomColors[Math.floor(Math.random() * (randomColors.length + 1))]),
    _useState2 = _slicedToArray$2(_useState, 1),
    randomColor = _useState2[0];
  function getColorFromType(type) {
    switch (type) {
      case 'Organizer':
        return 'purple';
      case 'AE':
      case 'User':
        return 'grape';
      case 'Company':
        return 'extraMeeting';
      case 'Lead':
        return 'extraMeeting';
      default:
        return 'random';
    }
  }
  function getStatusAvatar(status) {
    switch (status) {
      case 'yes':
        return {
          bagdeColor: 'lightestCall',
          icon: 'check',
          iconColor: 'extraCall'
        };
      case 'no':
        return {
          bagdeColor: 'lightestMeeting',
          icon: 'cross',
          iconColor: 'extraMeeting'
        };
      default:
        return {
          bagdeColor: 'verySoftPeanut',
          icon: 'arrowRight',
          iconColor: 'softPeanut'
        };
    }
  }
  var calculatedColor = getColorFromType(invitee === null || invitee === void 0 ? void 0 : invitee.type);
  var colorToUse = calculatedColor === 'random' ? randomColor : calculatedColor;
  var statusAvatar = getStatusAvatar(invitee === null || invitee === void 0 ? void 0 : invitee.status);
  var parentRef = useRef();
  return /*#__PURE__*/jsx(Fragment, {
    children: ((invitee === null || invitee === void 0 ? void 0 : invitee.email) || (invitee === null || invitee === void 0 ? void 0 : invitee.name)) && /*#__PURE__*/jsxs("div", {
      className: styles$5._invitee_card,
      style: {
        width: width || null
      },
      children: [/*#__PURE__*/jsx(CompoundIcon, {
        parent: /*#__PURE__*/jsx(Avatar, {
          size: "tiny",
          color: colorToUse,
          ref: parentRef,
          children: (invitee === null || invitee === void 0 ? void 0 : (_invitee$email = invitee.email) === null || _invitee$email === void 0 ? void 0 : _invitee$email.slice(0, 2).toUpperCase()) || (invitee === null || invitee === void 0 ? void 0 : (_invitee$name = invitee.name) === null || _invitee$name === void 0 ? void 0 : _invitee$name.slice(0, 2).toUpperCase())
        }),
        parentRef: parentRef,
        children: shouldShowStatus && /*#__PURE__*/jsx(Avatar, {
          size: "supertiny",
          color: statusAvatar.bagdeColor,
          children: /*#__PURE__*/jsx(Icon, {
            name: statusAvatar.icon,
            color: statusAvatar.iconColor,
            size: 10
          })
        })
      }), /*#__PURE__*/jsxs("div", {
        className: styles$5._invitee_info,
        children: [(invitee === null || invitee === void 0 ? void 0 : invitee.name) && /*#__PURE__*/jsx(Text, {
          size: "xs",
          children: invitee === null || invitee === void 0 ? void 0 : invitee.name
        }), (invitee === null || invitee === void 0 ? void 0 : invitee.type) === 'Lead' && !(invitee !== null && invitee !== void 0 && invitee.email) && /*#__PURE__*/jsx(Text, {
          size: "xs",
          color: "tomato",
          decoration: "underscore",
          children: "Lead has no email, it won't be invited"
        }), /*#__PURE__*/jsx(Text, {
          size: "xxs",
          color: invitee !== null && invitee !== void 0 && invitee.name ? 'softPeanut' : 'peanut',
          decoration: "underscore",
          children: invitee === null || invitee === void 0 ? void 0 : invitee.email
        })]
      }), (invitee === null || invitee === void 0 ? void 0 : invitee.type) && /*#__PURE__*/jsx(Label, {
        size: "small",
        uppercase: false,
        children: invitee === null || invitee === void 0 ? void 0 : invitee.type
      }), !readOnly && /*#__PURE__*/jsx(IconButton, {
        name: "cross",
        size: 24,
        color: "softPeanut",
        onClick: function onClick() {
          return handleRemoveInvitee(invitee === null || invitee === void 0 ? void 0 : invitee.email);
        }
      })]
    })
  });
}

var css_248z$4 = ".meetingDetail-module_container__ulcXy {\n  padding-top: 4px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.meetingDetail-module_htmlBody__BfK-4 > * {\n  font-size: 10px;\n}\n.meetingDetail-module_htmlBody__BfK-4 {\n  overflow: auto;\n  flex: 1;\n}\n\n.meetingDetail-module_header__-uklX {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  justify-content: space-between;\n}\n\n.meetingDetail-module_headerLeft__uPP1W {\n  display: flex;\n  align-items: center;\n  max-width: 240px;\n  overflow: hidden;\n}\n\n.meetingDetail-module_headerLeft__uPP1W > p {\n  margin-right: 0.3em;\n  display: flex;\n}\n\n.meetingDetail-module_time__e4ehg {\n  display: flex;\n  align-items: center;\n}\n\n.meetingDetail-module_badge__uXRsC {\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 8px;\n}\n\n.meetingDetail-module_meetingInfoWrapper__QG5AA {\n  padding: 6px 14px 45px 18px;\n}\n\n.meetingDetail-module_meetingInfo__8cqxK > p:first-child {\n  margin-bottom: 4px;\n}\n\n.meetingDetail-module_loading__WLdJI {\n  margin: auto;\n  width: 90%;\n  height: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.meetingDetail-module_reportResultButton__MpUYR {\n  display: block;\n  color: var(--melon);\n  white-space: nowrap;\n  max-width: 190px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  border: none;\n}\n\n.meetingDetail-module_disabledButton__qGsK5 {\n  color: var(--softCondition);\n}\n\n.meetingDetail-module_reportResultButton__MpUYR > svg {\n  margin-bottom: 1px;\n}\n";
var styles$4 = {"container":"meetingDetail-module_container__ulcXy","htmlBody":"meetingDetail-module_htmlBody__BfK-4","header":"meetingDetail-module_header__-uklX","headerLeft":"meetingDetail-module_headerLeft__uPP1W","time":"meetingDetail-module_time__e4ehg","badge":"meetingDetail-module_badge__uXRsC","meetingInfoWrapper":"meetingDetail-module_meetingInfoWrapper__QG5AA","meetingInfo":"meetingDetail-module_meetingInfo__8cqxK","loading":"meetingDetail-module_loading__WLdJI","reportResultButton":"meetingDetail-module_reportResultButton__MpUYR","disabledButton":"meetingDetail-module_disabledButton__qGsK5"};
styleInject(css_248z$4);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }
function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
var DetailedActivity = function DetailedActivity(_ref) {
  var activity = _ref.activity,
    dataModel = _ref.dataModel,
    userId = _ref.userId,
    actionsDisabled = _ref.actionsDisabled;
  var creationDate = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CREATION_DATETIME);
  var scheduledDate = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.TIME);
  var creationDateTime = creationDate && formatDate(new Date(creationDate), 'MMM dd yyyy, HH:mm');
  var scheduledDateTime = scheduledDate && formatDate(new Date(scheduledDate), 'MMM dd yyyy, HH:mm');
  var reminder = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.REMINDER_TEMPLATE);
  var result = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_RESULT);
  var assignedTo = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_ASSIGNED_TO);
  var meetingTitle = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.TITLE);
  var meetingInvitees = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_INVITEES);
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var parsedInvitees = meetingInvitees ? JSON.parse(meetingInvitees) : null;
  var meetingNote = useMemo(function () {
    var textFromLogicRole = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.NOTE);
    if (!textFromLogicRole) return null;
    return "<p>".concat(linkify(textFromLogicRole), "</p>");
  }, [activity]);
  var meetingCalendarNote = useMemo(function () {
    return linkify(getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.CALENDAR_NOTE));
  }, [activity]);
  var hasNylasID = !!getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.UNIQUE_NYLAS_ID);
  return /*#__PURE__*/jsxs("div", {
    className: styles$4.htmlBody,
    children: [/*#__PURE__*/jsx(ActivityTimelineItem, {
      activity: activity,
      startDisplayDivider: false,
      endDisplayDivider: false,
      extended: true,
      activeHover: false,
      alternativeDescription: true,
      dataModel: dataModel,
      userId: userId,
      actionsDisabled: actionsDisabled
    }), /*#__PURE__*/jsxs("div", {
      className: styles$4.meetingInfoWrapper,
      children: [/*#__PURE__*/jsxs("div", {
        className: styles$4.meetingInfo,
        children: [/*#__PURE__*/jsx(Text, {
          size: "s",
          weight: "bold",
          children: meetingTitle
        }), /*#__PURE__*/jsxs(Text, {
          size: "s",
          color: "softPeanut",
          children: ["Scheduled for: ", scheduledDateTime || 'Unknown']
        })]
      }), /*#__PURE__*/jsxs(ExpandedBoxSection, {
        grid: true,
        children: [/*#__PURE__*/jsx(InfoBox, {
          icon: "calendar",
          title: "Meeting creation",
          info: creationDateTime || 'Unknown'
        }), /*#__PURE__*/jsx(InfoBox, {
          icon: "bell",
          title: "Reminder set",
          info: reminder
        }), /*#__PURE__*/jsx(InfoBox, {
          icon: "gridSquares",
          title: "Meeting result",
          info: result
        }), /*#__PURE__*/jsx(InfoBox, {
          icon: "person",
          title: "Assigned to",
          info: assignedTo
        })]
      }), /*#__PURE__*/jsx(ExpandedBoxSection, {
        children: /*#__PURE__*/jsx(InfoBox, {
          icon: "taskAction",
          title: "Note (calendar)",
          info: meetingCalendarNote
        })
      }), /*#__PURE__*/jsx(ExpandedBoxSection, {
        children: /*#__PURE__*/jsx(InfoBox, {
          icon: "people",
          title: "Guests",
          info: (parsedInvitees === null || parsedInvitees === void 0 ? void 0 : parsedInvitees.length) > 0 ? /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx("div", {
              className: styles$4.invitees_container,
              children: parsedInvitees === null || parsedInvitees === void 0 ? void 0 : parsedInvitees.map(function (invitee, index) {
                if (!showMore && index > 2) {
                  return null;
                }
                return /*#__PURE__*/jsx("div", {
                  className: styles$4.invitees,
                  children: /*#__PURE__*/jsx(InviteeCard, {
                    invitee: invitee,
                    readOnly: true,
                    shouldShowStatus: hasNylasID
                  })
                }, "".concat(index).concat(invitee.email));
              })
            }), (parsedInvitees === null || parsedInvitees === void 0 ? void 0 : parsedInvitees.length) > 3 && /*#__PURE__*/jsx("div", {
              style: {
                cursor: 'pointer'
              },
              onClick: function onClick() {
                return setShowMore(!showMore);
              },
              children: /*#__PURE__*/jsxs(Text, {
                className: styles$4.showMore,
                size: "xs",
                color: "bloobirds",
                align: "center",
                children: ["Show ", showMore ? 'less' : 'more']
              })
            })]
          }) : undefined
        })
      }), /*#__PURE__*/jsx(ExpandedBoxSection, {
        children: /*#__PURE__*/jsx(InfoBox, {
          icon: "noteAction",
          title: "Note (internal)",
          info: meetingNote
        })
      })]
    })]
  });
};
var MeetingDetail = function MeetingDetail(_ref2) {
  var _getFieldByLogicRole;
  var activity = _ref2.activity,
    dataModel = _ref2.dataModel,
    _ref2$visibleFooter = _ref2.visibleFooter,
    visibleFooter = _ref2$visibleFooter === void 0 ? true : _ref2$visibleFooter,
    onSave = _ref2.onSave,
    _ref2$actionsDisabled = _ref2.actionsDisabled,
    actionsDisabled = _ref2$actionsDisabled === void 0 ? false : _ref2$actionsDisabled,
    userId = _ref2.userId;
  var _useMinimizableModals = useMinimizableModals(),
    openMinimizableModal = _useMinimizableModals.openMinimizableModal;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    openedModal = _useState4[0],
    setOpenedModal = _useState4[1];
  function openMeetingModal() {
    var bobjectFieldsData = {};
    activity.fields.forEach(function (field) {
      bobjectFieldsData[field.logicRole || field.name] = field.value;
    });
    var company = getRelatedBobject(activity, 'Company');
    var lead = getRelatedBobject(activity, 'Lead');
    // @ts-ignore
    openMinimizableModal({
      type: 'calendarMeeting',
      bobject: activity,
      data: _objectSpread$1({
        company: company ? {
          name: getValueFromLogicRole(company, COMPANY_FIELDS_LOGIC_ROLE.NAME),
          url: companyUrl(company),
          data: company
        } : undefined,
        lead: lead && {
          name: getValueFromLogicRole(lead, LEAD_FIELDS_LOGIC_ROLE.FULL_NAME),
          url: leadUrl(lead, null),
          data: lead
        }
      }, bobjectFieldsData),
      onSave: function onSave() {
        window.dispatchEvent(new CustomEvent('ACTIVE_BOBJECT_UPDATED', {
          detail: {
            type: BobjectTypes.Activity
          }
        }));
      },
      onClose: function onClose() {
        onSave === null || onSave === void 0 ? void 0 : onSave();
      }
    });
  }
  var isReported = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.REPORTED) === 'Yes';
  getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_MAIN_TYPE);
  var referenceBobject = getReferencedBobject(activity);
  var assignee = ((_getFieldByLogicRole = getFieldByLogicRole(referenceBobject, LEAD_FIELDS_LOGIC_ROLE.ASSIGNED_TO
  // @ts-ignore
  )) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.value) || (referenceBobject === null || referenceBobject === void 0 ? void 0 : referenceBobject.assignedTo);
  var assignedToActiveUser = assignee === userId;
  return /*#__PURE__*/jsxs("div", {
    className: styles$4.container,
    children: [!activity ? /*#__PURE__*/jsx("div", {
      className: styles$4.loading,
      children: /*#__PURE__*/jsx(Spinner, {
        name: "loadingCircle"
      })
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(DetailedActivity, {
        activity: activity,
        dataModel: dataModel,
        userId: userId,
        actionsDisabled: actionsDisabled
      }), visibleFooter && /*#__PURE__*/jsxs(DetailsFooter, {
        children: [!isReported ? /*#__PURE__*/jsxs(Button, {
          variant: "secondary",
          onClick: function onClick() {
            return setOpenedModal(true);
          },
          disabled: actionsDisabled && !assignedToActiveUser,
          children: [/*#__PURE__*/jsx(Icon, {
            name: "thumbsUp",
            size: 14
          }), "Report"]
        }) : /*#__PURE__*/jsxs(Button, {
          variant: "primary",
          color: "verySoftMelon",
          className: clsx(styles$4.reportResultButton, _defineProperty$1({}, styles$4.disabledButton, actionsDisabled && !assignedToActiveUser)),
          onClick: function onClick() {
            return setOpenedModal(true);
          },
          disabled: actionsDisabled && !assignedToActiveUser,
          children: [/*#__PURE__*/jsx(Icon, {
            name: "thumbsUp",
            size: 14,
            color: "melon"
          }), "Reported"]
        }), /*#__PURE__*/jsxs(Button, {
          variant: "secondary",
          onClick: openMeetingModal,
          disabled: actionsDisabled && !assignedToActiveUser,
          children: [/*#__PURE__*/jsx(Icon, {
            name: "edit",
            size: 14
          }), "Edit"]
        })]
      })]
    }), openedModal && /*#__PURE__*/jsx(MeetingReportResultModal, {
      activity: activity,
      handleClose: function handleClose() {
        setOpenedModal(false);
        onSave === null || onSave === void 0 ? void 0 : onSave();
      },
      dataModel: dataModel
    })]
  });
};

var css_248z$3 = ".noteDetail-module_container__tXMKA {\n  display: flex;\n  flex-direction: column;\n  height: 96%;\n  box-sizing: border-box;\n}\n\n.noteDetail-module_detail_content_container__KvIAf {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.noteDetail-module_body_wrapper__8w0qN {\n  height: 315px;\n}\n\n.noteDetail-module_body_wrapper__8w0qN > div > div ul {\n  padding-left: 24px !important;\n}\n\n.noteDetail-module_body_wrapper__8w0qN > div > div ol {\n  padding-left: 24px !important;\n}\n\n.noteDetail-module_bottom_bar__7pK7y {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n}\n\n.noteDetail-module_text__Ypj2A {\n  margin-left: 4px;\n}\n\n.noteDetail-module_record_related__39BgJ {\n  display: flex;\n  align-items: center;\n}\n\n.noteDetail-module_editor__ORH-S {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.noteDetail-module_divider__h9UsI {\n  width: 90%;\n  text-align: center;\n  border-top: 1px solid var(--verySoftPeanut);\n  align-self: center;\n}\n\n.noteDetail-module_bobject_selector__hss6p {\n  margin-left: 8px;\n}\n\n.noteDetail-module_toolbar__NbY-h {\n  border-top: 1px solid var(--verySoftPeanut);\n  border-bottom: 1px solid var(--verySoftPeanut);\n}\n\n.noteDetail-module_mainNote__NWqKJ {\n  margin-right: 4px;\n}\n";
var styles$3 = {"container":"noteDetail-module_container__tXMKA","detail_content_container":"noteDetail-module_detail_content_container__KvIAf","body_wrapper":"noteDetail-module_body_wrapper__8w0qN","bottom_bar":"noteDetail-module_bottom_bar__7pK7y","text":"noteDetail-module_text__Ypj2A","record_related":"noteDetail-module_record_related__39BgJ","editor":"noteDetail-module_editor__ORH-S","divider":"noteDetail-module_divider__h9UsI","bobject_selector":"noteDetail-module_bobject_selector__hss6p","toolbar":"noteDetail-module_toolbar__NbY-h","mainNote":"noteDetail-module_mainNote__NWqKJ"};
styleInject(css_248z$3);

var _excluded = ["related"];
var _mainNoteField;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var mainNoteField = (_mainNoteField = {}, _defineProperty(_mainNoteField, BOBJECT_TYPES.COMPANY, [COMPANY_FIELDS_LOGIC_ROLE.MAIN_NOTE]), _defineProperty(_mainNoteField, BOBJECT_TYPES.LEAD, [LEAD_FIELDS_LOGIC_ROLE.MAIN_NOTE]), _defineProperty(_mainNoteField, BOBJECT_TYPES.OPPORTUNITY, [OPPORTUNITY_FIELDS_LOGIC_ROLE.MAIN_NOTE]), _mainNoteField);
var defaultNewNoteValueTitle = [{
  type: 'h2',
  children: [{
    text: 'New note:'
  }]
}];
var NoteDetail = function NoteDetail(_ref) {
  var _relatedLead$id, _relatedCompany$id, _relatedOpportunity$i, _activity$id3;
  var activity = _ref.activity,
    dataModel = _ref.dataModel,
    accountId = _ref.accountId,
    _ref$visibleHeader = _ref.visibleHeader,
    visibleHeader = _ref$visibleHeader === void 0 ? false : _ref$visibleHeader;
  var noteTitle = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.TITLE);
  var noteContent = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.NOTE);
  var noteMainNoteValue = getTextFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MAIN_NOTE);
  var relatedCompany = getReferencedBobjectFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.COMPANY);
  var relatedLead = getReferencedBobjectFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.LEAD);
  var relatedOpportunity = getReferencedBobjectFromLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.OPPORTUNITY);
  var relatedCompanyName = getTextFromLogicRole(relatedCompany, COMPANY_FIELDS_LOGIC_ROLE.NAME);
  var relatedLeadName = getTextFromLogicRole(relatedLead, LEAD_FIELDS_LOGIC_ROLE.FULL_NAME);
  var relatedOpportunityName = getTextFromLogicRole(relatedOpportunity, OPPORTUNITY_FIELDS_LOGIC_ROLE.NAME);
  var titlePlugins = useRichTextEditorPlugins({
    singleLine: true
  });
  var plugins = useRichTextEditorPlugins({
    images: false,
    replaceParagraphs: true
  });
  var defaultValues = {
    title: noteTitle && typeof noteTitle === 'string' ? deserialize(noteTitle, {
      format: 'HTML',
      plugins: titlePlugins
    }) : defaultNewNoteValueTitle,
    body: noteContent && typeof noteContent === 'string' ? deserialize(noteContent, {
      format: 'HTML',
      plugins: plugins
    }) : null,
    mainNote: noteMainNoteValue === 'Main note Yes'
  };
  var defaultRelated = relatedLead ? relatedLead === null || relatedLead === void 0 ? void 0 : (_relatedLead$id = relatedLead.id) === null || _relatedLead$id === void 0 ? void 0 : _relatedLead$id.value : relatedCompany ? relatedCompany === null || relatedCompany === void 0 ? void 0 : (_relatedCompany$id = relatedCompany.id) === null || _relatedCompany$id === void 0 ? void 0 : _relatedCompany$id.value : relatedOpportunity ? relatedOpportunity === null || relatedOpportunity === void 0 ? void 0 : (_relatedOpportunity$i = relatedOpportunity.id) === null || _relatedOpportunity$i === void 0 ? void 0 : _relatedOpportunity$i.value : null;
  var defaultName = relatedLead ?
  // @ts-ignore
  (relatedLead === null || relatedLead === void 0 ? void 0 : relatedLead.fullName) || relatedLeadName || 'Untitled lead' : relatedCompany ?
  // @ts-ignore
  (relatedCompany === null || relatedCompany === void 0 ? void 0 : relatedCompany.name) || relatedCompanyName || 'Untitled company' : relatedOpportunity ?
  // @ts-ignore
  (relatedOpportunity === null || relatedOpportunity === void 0 ? void 0 : relatedOpportunity.name) || relatedOpportunityName || 'Untitled opportunity' : null;
  var _useForm = useForm(),
    control = _useForm.control,
    getValues = _useForm.getValues,
    handleSubmit = _useForm.handleSubmit;
  var _useState = useState(defaultName),
    _useState2 = _slicedToArray(_useState, 2),
    nameSelected = _useState2[0],
    setNameSelected = _useState2[1];
  var _useToasts = useToasts(),
    createToast = _useToasts.createToast;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];
  var _useController = useController({
      control: control,
      name: ACTIVITY_FIELDS_LOGIC_ROLE.TITLE,
      defaultValue: defaultValues.title
    }),
    _useController$field = _useController.field,
    title = _useController$field.value,
    titleOnChange = _useController$field.onChange;
  var _useController2 = useController({
      control: control,
      name: ACTIVITY_FIELDS_LOGIC_ROLE.MAIN_NOTE,
      defaultValue: defaultValues.mainNote
    }),
    _useController2$field = _useController2.field,
    mainNote = _useController2$field.value,
    mainNoteOnChange = _useController2$field.onChange;
  var _useController3 = useController({
      control: control,
      name: ACTIVITY_FIELDS_LOGIC_ROLE.NOTE,
      defaultValue: defaultValues.body
    }),
    _useController3$field = _useController3.field,
    note = _useController3$field.value,
    noteOnChange = _useController3$field.onChange;
  var _useController4 = useController({
      control: control,
      name: 'related',
      defaultValue: defaultRelated
    }),
    relatedOnChange = _useController4.field.onChange;
  var onSubmit = function onSubmit() {
    var _dataToCreate, _activity$id;
    setIsSubmitting(true);
    var _getValues = getValues(),
      related = _getValues.related,
      rest = _objectWithoutProperties(_getValues, _excluded);
    var isMainNote = rest[ACTIVITY_FIELDS_LOGIC_ROLE.MAIN_NOTE];
    var dataToCreate = (_dataToCreate = {}, _defineProperty(_dataToCreate, ACTIVITY_FIELDS_LOGIC_ROLE.TITLE, rest[ACTIVITY_FIELDS_LOGIC_ROLE.TITLE] ? serialize(rest[ACTIVITY_FIELDS_LOGIC_ROLE.TITLE], {
      format: 'AST',
      plugins: plugins
    }) : null), _defineProperty(_dataToCreate, ACTIVITY_FIELDS_LOGIC_ROLE.NOTE, rest[ACTIVITY_FIELDS_LOGIC_ROLE.NOTE] ? serialize(rest[ACTIVITY_FIELDS_LOGIC_ROLE.NOTE], {
      format: 'AST',
      plugins: plugins
    }) : null), _defineProperty(_dataToCreate, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE, ACTIVITY_TYPES_VALUES_LOGIC_ROLE.NOTE), _defineProperty(_dataToCreate, ACTIVITY_FIELDS_LOGIC_ROLE.MAIN_NOTE, isMainNote ? ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE.YES : ACTIVITY_MAIN_NOTE_VALUES_LOGIC_ROLE.NO), _dataToCreate);
    var relatedBobjectType;
    if (related) {
      if (related !== null && related !== void 0 && related.includes('Lead')) {
        relatedBobjectType = BOBJECT_TYPES.LEAD;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.LEAD] = related;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.COMPANY] = null;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.OPPORTUNITY] = null;
      } else if (related !== null && related !== void 0 && related.includes('Company')) {
        relatedBobjectType = BOBJECT_TYPES.COMPANY;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.COMPANY] = related;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.LEAD] = null;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.OPPORTUNITY] = null;
      } else if (related !== null && related !== void 0 && related.includes('Opportunity')) {
        relatedBobjectType = BOBJECT_TYPES.OPPORTUNITY;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.OPPORTUNITY] = related;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.COMPANY] = null;
        dataToCreate[ACTIVITY_FIELDS_LOGIC_ROLE.LEAD] = null;
      }
    }
    api.patch("/bobjects/".concat(activity === null || activity === void 0 ? void 0 : (_activity$id = activity.id) === null || _activity$id === void 0 ? void 0 : _activity$id.value, "/raw"), {
      contents: _objectSpread({}, dataToCreate),
      params: {}
    }).then(function () {
      setIsSubmitting(false);
      createToast({
        message: 'Note updated successfully',
        type: 'success'
      });
      if (isMainNote && related && relatedBobjectType) {
        var _activity$id2;
        api.patch("/bobjects/".concat(related, "/raw"), {
          contents: _defineProperty({}, mainNoteField[relatedBobjectType], [activity === null || activity === void 0 ? void 0 : (_activity$id2 = activity.id) === null || _activity$id2 === void 0 ? void 0 : _activity$id2.value])
        });
      } else if (!isMainNote && related && relatedBobjectType) {
        api.patch("/bobjects/".concat(related, "/raw"), {
          contents: _defineProperty({}, mainNoteField[relatedBobjectType], null)
        });
      }
    })["catch"](function () {
      setIsSubmitting(false);
    });
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles$3.container,
    children: [visibleHeader && /*#__PURE__*/jsx(ActivityTimelineItem, {
      activity: activity,
      startDisplayDivider: false,
      endDisplayDivider: false,
      activeHover: false,
      extended: true,
      dataModel: dataModel
    }), /*#__PURE__*/jsxs("div", {
      className: styles$3.detail_content_container,
      children: [/*#__PURE__*/jsxs("div", {
        className: styles$3.editor,
        children: [/*#__PURE__*/jsx(RichTextEditor, {
          id: 'note-detail-title',
          defaultValue: title,
          placeholder: "New note: ",
          plugins: titlePlugins,
          onChange: titleOnChange,
          style: {
            padding: '0px 24px 4px 24px'
          }
        }), /*#__PURE__*/jsx("span", {
          className: styles$3.divider
        }), /*#__PURE__*/jsx(RichTextEditor, {
          id: 'note-detail-body',
          defaultValue: note,
          plugins: plugins,
          placeholder: "Start typing your new note...",
          onChange: noteOnChange,
          style: {
            padding: '12px 28px 4px 28px'
          },
          children: function children(editor) {
            return /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx("div", {
                className: styles$3.body_wrapper,
                children: editor
              }), /*#__PURE__*/jsx("div", {
                className: styles$3.toolbar,
                children: /*#__PURE__*/jsxs(EditorToolbar, {
                  backgroundColor: "var(--peanut) !important",
                  children: [/*#__PURE__*/jsx(EditorToolbarControlsSection, {
                    color: "peanut"
                  }), /*#__PURE__*/jsx(EditorToolbarFontStylesSection, {
                    color: "peanut"
                  }), /*#__PURE__*/jsx(EditorToolbarTextMarksSection, {
                    color: "peanut"
                  }), /*#__PURE__*/jsx(EditorToolbarListsSection, {
                    color: "peanut"
                  })]
                })
              })]
            });
          }
        })]
      }), /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsxs("div", {
          className: styles$3.bottom_bar,
          children: [/*#__PURE__*/jsx("span", {
            className: styles$3.record_related,
            children: /*#__PURE__*/jsx("div", {
              className: styles$3.bobject_selector,
              children: /*#__PURE__*/jsx(BobjectSelector, {
                accountId: accountId,
                selected: nameSelected,
                id: activity === null || activity === void 0 ? void 0 : (_activity$id3 = activity.id) === null || _activity$id3 === void 0 ? void 0 : _activity$id3.value,
                onBobjectChange: function onBobjectChange(bobject) {
                  var _bobject$rawBobject;
                  relatedOnChange(bobject === null || bobject === void 0 ? void 0 : (_bobject$rawBobject = bobject.rawBobject) === null || _bobject$rawBobject === void 0 ? void 0 : _bobject$rawBobject.id);
                  if ((bobject === null || bobject === void 0 ? void 0 : bobject.bobjectType) === BobjectTypes.Company) {
                    setNameSelected((bobject === null || bobject === void 0 ? void 0 : bobject.companyName) ||
                    //@ts-ignore
                    getTextFromLogicRole(bobject, COMPANY_FIELDS_LOGIC_ROLE.NAME));
                  } else if ((bobject === null || bobject === void 0 ? void 0 : bobject.bobjectType) === BobjectTypes.Lead) {
                    setNameSelected((bobject === null || bobject === void 0 ? void 0 : bobject.fullName) ||
                    //@ts-ignore
                    getTextFromLogicRole(bobject, LEAD_FIELDS_LOGIC_ROLE.FULL_NAME));
                  } else if ((bobject === null || bobject === void 0 ? void 0 : bobject.bobjectType) === BobjectTypes.Opportunity) {
                    setNameSelected((bobject === null || bobject === void 0 ? void 0 : bobject.name) ||
                    //@ts-ignore
                    getTextFromLogicRole(bobject, OPPORTUNITY_FIELDS_LOGIC_ROLE.NAME));
                  }
                }
              })
            })
          }), /*#__PURE__*/jsxs("span", {
            children: [/*#__PURE__*/jsx(IconButton, {
              name: mainNote ? 'starChecked' : 'starUnchecked',
              onClick: function onClick() {
                mainNoteOnChange(!mainNote);
              },
              color: "bloobirds",
              size: 24,
              className: styles$3.mainNote
            }), /*#__PURE__*/jsx(Button, {
              size: "small",
              onClick: function onClick() {
                handleSubmit(onSubmit)();
              },
              disabled: isSubmitting,
              children: isSubmitting ? /*#__PURE__*/jsx(Spinner, {
                name: "loadingCircle",
                size: 12
              }) : 'Save'
            })]
          })]
        })
      })]
    })]
  });
};

var css_248z$2 = ".activityFeed-module_container__Sbnw- {\n  margin-top: 8px;\n  margin-right: 1px;\n}\n\n.activityFeed-module_loading__6MWSB {\n  display: flex;\n  justify-content: center;\n}\n\n.activityFeed-module_empty__Br4rM {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: auto;\n  width: 100%;\n  margin: 8px 8px;\n}\n\n.activityFeed-module_skeleton__eCUzF {\n  padding: 8px 6px 0 6px;\n}\n";
var styles$2 = {"container":"activityFeed-module_container__Sbnw-","loading":"activityFeed-module_loading__6MWSB","empty":"activityFeed-module_empty__Br4rM","skeleton":"activityFeed-module_skeleton__eCUzF"};
styleInject(css_248z$2);

var css_248z$1 = ".activityFeedSkeleton-module_card__zGJoF {\n  background-color: var(--white);\n  margin-bottom: 8px;\n  padding: 6px;\n}\n\n.activityFeedSkeleton-module_cardHeader__3-x9R {\n  display: flex;\n  gap: 6px;\n}\n\n.activityFeedSkeleton-module_cardHeader__3-x9R > *:last-child {\n  margin-left: auto;\n}\n\n.activityFeedSkeleton-module_cardHeaderText__PLGU5 {\n  width: 70%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n";
var styles$1 = {"card":"activityFeedSkeleton-module_card__zGJoF","cardHeader":"activityFeedSkeleton-module_cardHeader__3-x9R","cardHeaderText":"activityFeedSkeleton-module_cardHeaderText__PLGU5"};
styleInject(css_248z$1);

var ActivityCardSkeleton = function ActivityCardSkeleton() {
  return /*#__PURE__*/jsx("div", {
    className: styles$1.card,
    children: /*#__PURE__*/jsxs("header", {
      className: styles$1.cardHeader,
      children: [/*#__PURE__*/jsx(Skeleton, {
        variant: "circle",
        width: 16,
        height: 16
      }), /*#__PURE__*/jsx("div", {
        className: styles$1.cardHeaderText,
        children: /*#__PURE__*/jsx(Skeleton, {
          variant: "text",
          width: "100%",
          height: 16
        })
      }), /*#__PURE__*/jsx(Skeleton, {
        variant: "text",
        width: "10%",
        height: 16
      })]
    })
  });
};
var ActivityFeedSkeleton = function ActivityFeedSkeleton() {
  return /*#__PURE__*/jsx(Fragment, {
    children: range(4).map(function (number) {
      return /*#__PURE__*/jsx(Fragment$1, {
        children: /*#__PURE__*/jsx(ActivityCardSkeleton, {})
      }, number);
    })
  });
};

var ActivityFeed = function ActivityFeed(_ref) {
  var isLoading = _ref.isLoading,
    activities = _ref.activities,
    handleOnClick = _ref.handleOnClick,
    total = _ref.total,
    parentRef = _ref.parentRef,
    fetchNextPage = _ref.fetchNextPage,
    estimateSize = _ref.estimateSize,
    fixedHeight = _ref.fixedHeight,
    _ref$extended = _ref.extended,
    extended = _ref$extended === void 0 ? false : _ref$extended,
    dataModel = _ref.dataModel,
    _ref$actionsDisabled = _ref.actionsDisabled,
    actionsDisabled = _ref$actionsDisabled === void 0 ? false : _ref$actionsDisabled,
    _ref$sidePeekEnabled = _ref.sidePeekEnabled,
    sidePeekEnabled = _ref$sidePeekEnabled === void 0 ? false : _ref$sidePeekEnabled,
    _ref$enabledArrowNavi = _ref.enabledArrowNavigation,
    enabledArrowNavigation = _ref$enabledArrowNavi === void 0 ? false : _ref$enabledArrowNavi;
  var userId = useActiveUserId();
  var isFetching = !activities;
  if (!isLoading && (activities === null || activities === void 0 ? void 0 : activities.length) === 0) {
    return /*#__PURE__*/jsx("div", {
      className: styles$2.empty,
      children: /*#__PURE__*/jsx(Text, {
        size: "s",
        color: "softPeanut",
        children: "No activities pending"
      })
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: styles$2.container,
    children: /*#__PURE__*/jsx(Timeline, {
      size: 'small',
      children: /*#__PURE__*/jsx(VirtualInfiniteScroll, {
        enableSelectedBackground: true,
        enabledArrowNavigation: enabledArrowNavigation,
        onNavigation: handleOnClick,
        parentRef: parentRef,
        rows: activities,
        totalRows: total,
        isFetchingData: isFetching,
        fetchNextPage: fetchNextPage,
        hasNextItem: function hasNextItem(index) {
          return index !== total - 1;
        },
        contentSkeleton: function contentSkeleton() {
          return /*#__PURE__*/jsx("div", {
            className: styles$2.skeleton,
            children: /*#__PURE__*/jsx(ActivityFeedSkeleton, {})
          });
        },
        loaderSkeleton: function loaderSkeleton() {
          return /*#__PURE__*/jsx("div", {
            className: styles$2.skeleton,
            children: /*#__PURE__*/jsx(ActivityFeedSkeleton, {})
          });
        },
        estimateSize: estimateSize,
        fixedHeight: fixedHeight && extended,
        children: function children(activity, hasNext, isFirst, selected) {
          var _getFieldByLogicRole, _activity$id, _activity$id2;
          var activityType = (_getFieldByLogicRole = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE)) === null || _getFieldByLogicRole === void 0 ? void 0 : _getFieldByLogicRole.valueLogicRole;
          return (activity === null || activity === void 0 ? void 0 : (_activity$id = activity.id) === null || _activity$id === void 0 ? void 0 : _activity$id.objectId) && /*#__PURE__*/jsx(ActivityTimelineItem, {
            activity: activity,
            onClick: activityType !== 'ACTIVITY__TYPE__CADENCE' ? handleOnClick : undefined,
            startDisplayDivider: !isFirst,
            endDisplayDivider: hasNext,
            extended: extended,
            dataModel: dataModel,
            actionsDisabled: actionsDisabled,
            userId: userId,
            sidePeekEnabled: sidePeekEnabled,
            activeHover: !selected
          }, activity === null || activity === void 0 ? void 0 : (_activity$id2 = activity.id) === null || _activity$id2 === void 0 ? void 0 : _activity$id2.value);
        }
      })
    })
  });
};

var css_248z = ".activityDetails-module_container__xTL-m {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding-top: 24px;\n}\n\n\n.activityDetails-module_container__xTL-m > div:first-child > button {\n  padding-left: 24px;\n}\n\n.activityDetails-module_detailsContainer__6RIan {\n  flex: 1;\n  max-height: 94%;\n}\n";
var styles = {"container":"activityDetails-module_container__xTL-m","detailsContainer":"activityDetails-module_detailsContainer__6RIan"};
styleInject(css_248z);

var ActivityDetails = function ActivityDetails(_ref) {
  var _activityToRender$id;
  var activity = _ref.activity,
    callback = _ref.callback,
    dataModel = _ref.dataModel,
    _ref$visibleFooter = _ref.visibleFooter,
    visibleFooter = _ref$visibleFooter === void 0 ? true : _ref$visibleFooter,
    selectedActivity = _ref.selectedActivity;
  var activityToRender = selectedActivity || activity;
  var activityType = getTextFromLogicRole(activityToRender, ACTIVITY_FIELDS_LOGIC_ROLE.TYPE);
  var accountId = activityToRender === null || activityToRender === void 0 ? void 0 : (_activityToRender$id = activityToRender.id) === null || _activityToRender$id === void 0 ? void 0 : _activityToRender$id.accountId;
  var getActivityDetail = function getActivityDetail() {
    switch (activityType) {
      case ACTIVITY_TYPES.EMAIL:
        {
          var emailThreadId = getTextFromLogicRole(activityToRender, ACTIVITY_FIELDS_LOGIC_ROLE.EMAIL_THREAD_ID);
          return /*#__PURE__*/jsx(EmailThreadDetail, {
            activity: activityToRender,
            emailThreadId: emailThreadId,
            accountId: accountId /*Temporal approach*/,
            dataModel: dataModel,
            visibleFooter: visibleFooter
          });
        }
      case ACTIVITY_TYPES.LINKEDIN:
        {
          return /*#__PURE__*/jsx(LinkedInDetail, {
            activity: activity,
            accountId: accountId,
            dataModel: dataModel,
            visibleFooter: visibleFooter
          });
        }
      case ACTIVITY_TYPES.MEETING:
        {
          return /*#__PURE__*/jsx(MeetingDetail, {
            activity: activity,
            dataModel: dataModel,
            visibleFooter: visibleFooter,
            onSave: callback
          });
        }
      case ACTIVITY_TYPES.CALL:
        {
          return /*#__PURE__*/jsx(CallDetail, {
            activity: activity,
            dataModel: dataModel,
            visibleFooter: visibleFooter
          });
        }
      case ACTIVITY_TYPES.INBOUND:
        {
          return /*#__PURE__*/jsx(InboundDetail, {
            activity: activity,
            dataModel: dataModel
          });
        }
      case ACTIVITY_TYPES.NOTE:
        {
          return /*#__PURE__*/jsx(NoteDetail, {
            activity: activity,
            dataModel: dataModel,
            accountId: accountId,
            visibleHeader: true
          });
        }
      default:
        return /*#__PURE__*/jsx(Text, {
          color: "extraMeeting",
          align: "center",
          size: "s",
          weight: "bold",
          children: "No page available"
        });
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(Button, {
        iconLeft: "arrowLeft",
        size: "small",
        color: "bloobirds",
        onClick: callback,
        variant: "clear",
        uppercase: false,
        children: "Back to list"
      })
    }), /*#__PURE__*/jsx("div", {
      className: styles.detailsContainer,
      children: getActivityDetail()
    })]
  });
};

export { ActivityDetails, ActivityFeed, ActivityTimelineItem, AttachmentsDropdown, CallDetail, EmailThreadDetail, InboundDetail, LinkedInDetail, MeetingDetail, NoteDetail };
